<template>
  <div>
    <b-row>
      <!----- SideBar All Design List ---->
      <div class="detailside" v-if="isSidebarRefresh==true" key="sidebar1">
        <sidebarAllDesignsComponent></sidebarAllDesignsComponent>
      </div>
       <div class="detailside" v-if="isSidebarRefresh==false" key="sidebar2">
        <sidebarAllDesignsComponent></sidebarAllDesignsComponent>
      </div>
      <!-- <div class="side">
   <sidebarAllDesignsComponent></sidebarAllDesignsComponent>
</div> -->
      <!----- SideBar All Design List End ---->

      <div class="design-container-details__main" style="width:70%">
        <div class="brand-card brandcard">
          <div class="col-md-12 designtitle" v-if="user_type != 'Fit_Technician' && user_type!= 'PO Executive'">
            <div class="col-md-12">
              Design Title:<strong>
                &nbsp;{{ style_details.design_title }}</strong
              >
            </div>
            <div class="col-md-12">
              Style Name : &nbsp;{{ style_details.style_name }} >>
              {{ style_details.sub_cattitle }}
            </div>
            <div class="col-md-12">
              Created Date : {{ style_details.created_date }}
            </div>
            <div v-if="this.style_details.sendqname === null" class="col-md-12">
              Buyer Name : {{ style_details.buyer_name }}
            </div>
            <div v-if="this.style_details.sendqname != null" class="col-md-12">
              Buyer Name : {{ style_details.sendqname }}
            </div>
          </div>
          <navbarMenu></navbarMenu>
          <br />

           <div id="modal_overlay" style="display: none">
            <div class="modal_loader"></div>
            <br />
            <span class="loading" style="color: #fff">Uploading File ..</span>
          </div>
          <!-- <b-col md="12" >
            
          <b-dropdown variant="link" style="float:right" toggle-class="text-decoration-none" no-caret >
            <template v-slot:button-content>
            <i class="fa fa-sliders" aria-hidden="true"></i>
            </template>
            <b-dropdown-item style="font-size: 20px;"> 
            <router-link :to="'/design_details/' + route_id" v-bind:class="design_tab_class" v-if="component_name=='design_details'" style="background-color: #F8F8FF">
    <div> 
      <div class="nav_tabs__tab flex nav_tabs__tab--active completed " data-tip="" data-class="dark-tooltip" currentitem="false">
          <div class="nav_tabs__tab-image"> 
          <img src="../assets/images/ic-blue-check.2ce9e8ec.png" alt="progress icon"></div>
          <div class="nav_tabs__tab-block" style="width: 100px;"><span class="title" id="activeTitle">Design Details</span><span class="sub_title completed">Completed</span></div>
      </div>    
    </div>
  </router-link>
          
     
      
     
        
            </b-dropdown-item>
          </b-dropdown>
          </b-col> -->

          <!-- <div id="myNav" class="overlay">
  <a href="javascript:void(0)" class="closebtn" @click="closeNav()">&times;</a>
  <div class="overlay-content">
      <a class="design-container-details__sidebar-item flex f-w-semi-bold " href="/brands"><i class="fa fa-2x fa-angle-left"></i>&nbsp;&nbsp;&nbsp; 
        <span>All Designs</span>
        </a>
        <div>
          
        </div>
         <a v-for="designs in nav_design_list" :href="'/design_details/' + designs.style_id">
           <div class="design-list__item1" style="border-bottom:none ">
            <img v-bind:src="designs.style_image"  alt="Design" class="imgsidedesign">
           </div>
            <div class="design-list__title1 f-w-semi-bold" data-tip="WHITE HALF SLV T SHIRT" data-place="right" data-delay-show="500" currentitem="false" >
                           {{ designs.design_title.substring(0,22)+".." }}
                           </div>
                           <div class="design-list__subtitle1 f-sz-sm" style="text-transform: capitalize; color: var(--fill-grey-medium);">kids - girls clothing</div>
         </a>
     
  </div>
</div> -->
          <!--  <b-row class="col-md-12">
          <b-col md="12" >
              <button type="button" class="btn btn-default navbtn" @click="openNav()" style="color:#16A2D7"><i class="fa fa-list" aria-hidden="true" style="background-color: none; color: #0864d6; width: 20px;"></i>&nbsp;AllDesign</button> 
          </b-col>
        </b-row> -->

          <!-- <div class="col-md-12"> -->

          <!-- <div > -->
          <!-- <b-card  style="padding-top:10px;"> -->
         
          <div class="col-md-12">
            <b-row class="col-md-12 dropdowndesign">
              <b-col
                md="12"
                class="pull-right text-right"
                v-if="style_details.operational_status != 'DH-rejected'"
              >
                <!-- <div class="pull-right"> -->
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template v-slot:button-content>
                    <span
                      class="cui-options icons font-1xl d-block"
                      style="font-size: 20px;"
                    ></span>
                  </template>
                  <b-dropdown-item style="font-size: 20px;">
                    <button
                      type="button"
                      class="btn btn-default"
                      @click="getStyleActivityLog()"
                    >
                      <i
                        class="fa fa-exchange"
                        aria-hidden="true"
                        style="background-color: none; color: #DAA520; width: 20px;"
                      ></i
                      >Activity Logs
                    </button>
                  </b-dropdown-item>
                  
                  <b-dropdown-item style="font-size: 20px;" v-if="
                        (style_details.operational_status == 'Buyer-approved' || style_details.operational_status == 'TP-Uploaded' || style_details.operational_status == 'Measurement Chart-Uploaded' || style_details.operational_status == 'BOM-Updated' || style_details.operational_status == 'DH-approved') &&
                          (user_type == 'Buyer' || user_type == 'Brand_Manager')
                      ">
                    <button
                      type="button"
                      class="btn btn-default"
                      @click="getDesignDetailsModel(style_details)"
                    >
                      <i
                        class="fa fa-edit"
                        aria-hidden="true"
                        style="background-color: none; color: #DAA520; width: 20px;"
                      ></i
                      >Edit Design Details
                    </button>
                  </b-dropdown-item>

                  <!-- v-if="style_details.operational_status=='DH-Feedback' || style_details.operational_status=='BH-Feedback' || style_details.operational_status=='FH-Feedback' || style_details.is_draft==1" -->

                  <!-- v-if="style_details.operational_status=='DH-Feedback' || style_details.operational_status=='BH-Feedback' || style_details.operational_status=='FH-Feedback' || style_details.is_draft==1" -->
                  <!-- {{style_details.operational_status}} -->
                  <!-- || style_details.is_draft==1 -->
                  <b-dropdown-item  v-if="
                           ( (style_details.operational_status == 'DH-Feedback' ||
                          style_details.operational_status == 'BH-Feedback' ||
                          style_details.operational_status == 'FH-Feedback' ) &&
                          user_type == 'Brand_Designer') || (user_type == 'Brand_Designer' ||user_type == 'Brand_Manager' || user_type == 'Buyer')">
                    <button
                     
                      type="button"
                      class="btn btn-link"
                      @click="
                        editStyledesign(style_details);
                        setSelectedcolor(selected_pantone_no, 0);
                      "
                    >
                      <i
                        class="fa fa-pencil"
                        variant="primary"
                        aria-hidden="true"
                        style="color: #1E90FF; "
                      ></i
                      ><label style="color: #585858;">Edit Style</label>
                    </button>
                  </b-dropdown-item>

                  <b-dropdown-item  v-if="
                        (style_details.operational_status == 'StyleNoCreated') &&
                          user_type == 'Brand_Designer'
                      ">
                    <button
                     
                      type="button"
                      class="btn btn-default"
                      @click="
                        deleteStyle();
                      "
                    >
                      <i
                        class="fa fa-trash"
                        variant="primary"
                        aria-hidden="true"
                        style="color: #1E90FF; "
                      ></i
                      ><label style="color: #585858;">Delete Style</label>
                    </button>
                  </b-dropdown-item>

                  <!-- <b-dropdown-item >
              <button v-if="( style_details.is_draft==1 && user_type=='Brand_Manager')" type="button" class="btn btn-link" @click="editStyledesign(style_details);setSelectedcolor(selected_pantone_no,0)"><i class="fa fa-pencil" variant="primary" aria-hidden="true" style="color: #1E90FF; " ></i><label style="color: #585858;">Edit Style</label></button>
          </b-dropdown-item> -->

                  <b-dropdown-item
                    style="font-size: 20px;"
                    v-if="
                      user_type == 'Brand_Manager' &&
                        style_details.operational_status == 'DH-approved' &&
                        block_status != false
                    "
                  >
                    <button
                      type="button"
                      class="btn btn-default"
                      @click="addcomment"
                    >
                      <i
                        class="fa fa-pencil"
                        aria-hidden="true"
                        style="background-color: none; color: #6495ED; width: 20px;"
                      ></i
                      >Update Status
                    </button>
                  </b-dropdown-item>
                </b-dropdown>
                <!-- </div> -->
              </b-col>
            </b-row>

            <!-- Full screen overlay for side bar -->
          </div>

          <b-row class="col-md-12"> </b-row>

          <b-row class="detailsrow">
            <b-col cols="4">
             
              <div
                class="divdesign"
                v-if="finalImageType == 'image'"
              >
              
                <a :href="finalImage" download>
                  <img
                    v-bind:src="finalImage"
                    class="imgdesign"
                    style="width:300px;height:300px;"
                  />
                </a>
                <!-- v-b-modal.modal-lg type="button" -->

                <button @click="openimage" class="btn btn-success btndesign">
                  <i class="fa fa-search-plus" aria-hidden="true"
                    >&nbsp;Zoom Image</i
                  >
                </button>

                <!-- <button type="button" class="btn btn-success" @click="zoomin()"><i class="fa fa-search-plus" aria-hidden="true">&nbsp;Zoom In</i></button>&nbsp; -->
                <!-- <image-magnifier :src="style_details.style_image"
                    :zoom-src="style_details.style_image"
                    width="250"
                    height="270"
                    zoom-width="400"
                    zoom-height="300" style="padding:5px;"></image-magnifier> -->

                <b-form-group style="margin-top:25px;">
                  <!-- <b-form-file
                    v-model="file"
                    class="mt-3" 
                    placeholder="Update Design Image" 
                   ></b-form-file> -->
                  <!-- <input type="file"  @change="upload($event)" id="file-input" v-if="style_details.operational_status=='DH-Feedback' || style_details.operational_status=='BH-Feedback' || style_details.operational_status=='FH-Feedback'"> -->
                </b-form-group>
              </div>
              
              <div v-if="finalImageType == 'other'">
                <div id="pdfoverride">

                  <vue-pdf-embed
                    :source="finalImage"
                  ></vue-pdf-embed>
                </div>

                <div
                  style="display: flex; justify-content: center; align-items: center;"
                >
                  <button @click="openimage" class="btn btn-success btndesign">
                    <i class="fa fa-search-plus" aria-hidden="true"
                      >&nbsp;Zoom Image</i
                    >
                  </button>
                </div>

                <!-- <image-magnifier :source="style_details.style_image"
                      :zoom-source="style_details.style_image"
                      width="250"
                      height="270"
                      zoom-width="400"
                      zoom-height="300" style="padding:5px;">
                    </image-magnifier> -->
              </div>

              <div
                class="divdesign mt-2"
                v-if="
                  style_details.artwork_image != null &&
                    style_details.artwork_image != ''
                "
              >
                <p style="text-align:center" class="mt-2">Artwork Image</p>
                <img
                  v-bind:src="style_details.artwork_image"
                  class="imgdesign"
                  style="width:300px;height:300px;"
                />
                <p class="text-center">{{ style_details.artwork_title }}</p>
                <button
                  @click="openArtWorkimage"
                  class="btn btn-success btndesign mb-2"
                >
                  <i class="fa fa-search-plus" aria-hidden="true"
                    >&nbsp;Zoom Image</i
                  >
                </button>
              </div>
            </b-col>
            <!-- <b-col cols="2"></b-col> -->

            <b-col cols="6" class="coldesign">
              <div class="col-md-12 stylefield">
                <!-- <b-col md="6" class="pull-left"> -->
                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Style Name</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{style_details.style_name }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Style Code</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb">
                    {{ style_details.style_code }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Story Name</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb">
                    {{ style_details.story_name ? style_details.story_name : style_details.design_title }}
                  </b-col>
                </b-form-group>

                <!-- <b-form-group>
                    <b-col md="5" class="pull-left">
                    <label for="name"><b>Design ID</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                  <b-col md="6" class="pull-right">
                    {{style_details.design_title}}
                  </b-col>
                  </b-form-group> -->

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Segment</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb">
                    {{ style_details.segment_title }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Category Title</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{ style_details.category_title }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Sub Category</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{ style_details.sub_cattitle }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>PO Type</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{ style_details.potype_title }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Utility type</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{ style_details.utilitytype_title }}
                  </b-col>
                </b-form-group>
                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Panton Type</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{ style_details.panton_type }}
                  </b-col>
                </b-form-group>

                <!-- <b-form-group v-if="style_details.panton_type != 'OTHERS'" class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Panton Color</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{ style_details.pantone_no }}
                  </b-col>
                </b-form-group> -->

                <b-form-group class="mt-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Selected Color / Penton Color</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb">
                    <div class="mt-1" v-for="colors in selected_mutlicolor" :style="`background-color:${colors.split(' ').pop()}`">
                      {{ colors }}
                   </div>
                  
                  </b-col>
                </b-form-group>

                <!-- <b-form-group v-if="selected_panton_type != 'OTHERS'" class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Selected Color</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    ><div id="showcolor" class="selectedcolor"></div>
                  </b-col>
                </b-form-group> -->

                <!-- <b-form-group >
                    <b-col md="5" class="pull-left">
                    <label for="name"><b>Number Of Size Sets </b></label>
                  </b-col>
                    <b-col md="1" class="pull-left colonb"><b>:</b></b-col>
                     
                    <b-col md="6" class="pull-right titleb">{{selected_sizeset}}
                    </b-col>
                  </b-form-group> -->

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Design Hit</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{
                      style_details.design_hit ? style_details.design_hit : "NA"
                    }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Design Status</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{ style_details.design_status }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Operational Status </b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{ style_details.operational_status }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Style Description</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{ style_details.style_description }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0"
                  v-if="
                    style_details.sample_image != null &&
                      style_details.sample_image != ''
                  "
                >
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Sample Image</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb">
                    <a :href="style_details.sample_image" target="_blank"
                      ><i
                        class="fa fa-download"
                        aria-hidden="true"
                        v-b-tooltip.hover
                        title="Click to download"
                        style="font-size:20px;"
                      ></i
                    ></a>
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Created By</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{ style_details.full_name }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Designer Name</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{ style_details.designer_name }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Fit Tech Name</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{ style_details.fit_tech_name }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Buyer Name / BM Name</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col
                    md="6"
                    class="pull-right titleb"
                    v-if="this.style_details.sendqname === null"
                    >{{ style_details.buyer_name }}
                  </b-col>
                  <b-col
                    md="6"
                    class="pull-right titleb"
                    v-if="this.style_details.sendqname != null"
                    >{{ style_details.sendqname }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Created Date</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{ style_details.created_date }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0"
                  v-if="
                    style_details.artwork_created_by != null &&
                      style_details.artwork_created_by != ''
                  "
                >
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Artwork Created By</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{ style_details.artwork_created_by }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0"
                  v-if="
                    style_details.artwork_edited_by != null &&
                      style_details.artwork_edited_by != ''
                  "
                >
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Artwork Edited By</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{ style_details.artwork_edited_by }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Updated Date</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb">
                    {{ style_details.updated_date }}
                  </b-col>
                </b-form-group>

                <b-form-group class="m-0">
                  <b-col md="5" class="pull-left">
                    <label for="name"><b>Remark</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left colonb"><b>:</b></b-col>

                  <b-col md="6" class="pull-right titleb"
                    >{{ style_details.comments }}
                  </b-col>
                </b-form-group>

                <b-form-group class="styleform m-0">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Style Type</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    >{{ style_details.style_type }}
                  </b-col>
                </b-form-group>

                <b-form-group class="styleform m-0" v-if = "selected_sub_catid === 170">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Upper Material</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    >{{ style_details.upper_material }}
                  </b-col>
                </b-form-group>

                <b-form-group class="styleform m-0" v-if = "selected_sub_catid === 170">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Inner Lining</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    >{{ style_details.inner_lining }}
                  </b-col>
                </b-form-group>

                <b-form-group class="styleform m-0" v-if = "selected_sub_catid === 170">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Sole</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    >{{ style_details.sole }}
                  </b-col>
                </b-form-group>


                <b-form-group class="styleform m-0" v-if = "selected_sub_catid === 170">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Surface Ornamentation</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    >{{ style_details.surface_ornamentation }}
                  </b-col>
                </b-form-group>
                
                <b-form-group class="styleform m-0" v-if = "selected_sub_catid === 170">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Highlight</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    >{{ style_details.highlight }}
                  </b-col>
                </b-form-group>

                      
                <b-form-group class="styleform m-0" v-if = "selected_sub_catid === 170">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Fastening Type</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    >{{ style_details.fastening_type }}
                  </b-col>
                </b-form-group>


                <b-form-group class="styleform m-0" v-if = "selected_sub_catid !== 170">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Fabric Type</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    >{{ style_details.fabrictype }}
                  </b-col>
                </b-form-group>

                <b-form-group class="styleform m-0"  v-if = "selected_sub_catid !== 170">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Top Fabric/Upper Fabric</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    >{{ style_details.materialinfoupperfabric }}
                  </b-col>
                </b-form-group>

                <b-form-group class="styleform m-0"  v-if = "selected_sub_catid !== 170">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Bottom Fabric/Sole Material</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    >{{ style_details.solematerial }}
                  </b-col>
                </b-form-group>

                <b-form-group class="styleform m-0"  v-if = "selected_sub_catid !== 170">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Fabric Composition</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    >{{ style_details.fabriccomposition }}
                  </b-col>
                </b-form-group>

                <b-form-group class="styleform m-0"  v-if = "selected_sub_catid !== 170">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Sleeve Length</b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    >{{ style_details.sleevelength }}
                  </b-col>
                </b-form-group>
                <b-form-group class="styleform m-0">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Download PDF File </b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    ><a :href="style_details.pdf_file" target="_blank" v-if="style_details.pdf_file"><i class="fa fa-download" style="font-size:x-large"></i></a>
                    <span v-if="!style_details.pdf_file">NA</span>
                  </b-col>
                </b-form-group>
                <b-form-group class="styleform m-0"  v-if = "selected_sub_catid !== 170">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Material: </b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    ><span v-if="style_details.material">{{style_details.material}}</span>
                    <span v-if="!style_details.material">NA</span>
                  </b-col>
                </b-form-group>
                <b-form-group class="styleform m-0" v-if = "selected_sub_catid !== 170">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Pack Of: </b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    ><span v-if="style_details.pack_of">{{style_details.pack_of}}</span>
                    <span v-if="!style_details.pack_of">NA</span>
                  </b-col>
                </b-form-group>
                <b-form-group class="styleform m-0">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Epp </b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    ><span v-if="style_details.is_epp">{{style_details.is_epp}}</span>
                    <span v-if="!style_details.is_epp">NA</span>
                  </b-col>
  
                   
                </b-form-group>

                <b-form-group class="styleform m-0">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Style Comment </b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    ><span v-if="style_details.style_comment">{{style_details.style_comment}}</span>
                    <span v-if="!style_details.style_comment">NA</span>
                  </b-col>
  
                   
                </b-form-group>

                <b-form-group class="styleform m-0">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Design Head Grade </b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    ><span v-if="style_details.dh_grade">{{style_details.dh_grade}}</span>
                    <span v-if="!style_details.dh_grade">NA</span>
                  </b-col>
  
                   
                </b-form-group>
                <b-form-group class="styleform m-0">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Brand Manager Grade </b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    ><span v-if="style_details.bm_grade">{{style_details.bm_grade}}</span>
                    <span v-if="!style_details.bm_grade">NA</span>
                  </b-col>
                </b-form-group>

                <!-- <b-form-group class="styleform m-0">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Buying Head Grade </b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    ><span v-if="style_details.buyinghead_grade">{{style_details.buyinghead_grade}}</span>
                    <span v-if="!style_details.buyinghead_grade">NA</span>
                  </b-col>
                </b-form-group> -->
                <b-form-group class="styleform m-0" v-if="style_details.buyer_grade">
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Buyer Grade </b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    ><span v-if="style_details.buyer_grade">{{style_details.buyer_grade}}</span>
                    
                  </b-col>
                </b-form-group>

                <b-form-group class="styleform m-0" >
                  <b-col md="5" class="pull-left detailscol5">
                    <label for="name"><b>Final Grade / Fashion Head Grade </b></label>
                  </b-col>
                  <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                  <b-col md="6" class="pull-right detailscol6"
                    ><span v-if="style_details.final_grade">{{style_details.final_grade}}</span>
                    <span v-if="!style_details.final_grade">NA</span>
                  </b-col>
                </b-form-group>
                
              </div>
            </b-col>
          </b-row>
          <!-- New Code Added For Size -->
          <b-row class="col-md-12" v-if="temp_sizeset > 0">
            <table class="table table-striped">
              <thead class="requestedhead">
                <tr>
                  <td scope="col">Size Set</td>
                  <td scope="col">Unit</td>
                  <td scope="col"v-if = "selected_sub_catid !== 170">Age From</td>
                  <td scope="col"v-if = "selected_sub_catid !== 170">Age To</td> 
                  <td scope="col"v-if = "selected_sub_catid !== 170">Factory Size(In CM / In Inch)</td>
                  <td scope="col"v-if = "selected_sub_catid === 170">UK</td>
                  <td scope="col"v-if = "selected_sub_catid === 170">US</td>
                  <td scope="col"v-if = "selected_sub_catid === 170">Foot Length(In CM)</td>
                  <td scope="col"v-if = "selected_sub_catid === 170">Brand Size Euro</td>
                  <td colspan="1" scope="col">Quantity</td>
                  <td scope="col">MRP</td>
                </tr>
              </thead>
              <tbody class="requestedbody">
                <tr v-for="(invoice_product, index) in sizeset">
                  <td>
                    <label class="requestsize">Size &nbsp;</label
                    >{{ index + 1 }}
                  </td>

                  <td>
                    <b-form-input
                      type="text"
                      class="selected_month"
                      name="selected_month"
                      v-model="unit[index]"
                      :key="index"
                      required
                      disabled
                      readonly
                    ></b-form-input>
                  </td>
                 <td v-if = "selected_sub_catid !== 170">
                    <b-form-input
                      type="text"
                      class="selectedfromage"
                      name="selectedfromage"
                      v-model="selectedfromage[index]"
                      :key="index"
                      required
                      disabled
                      readonly
                    ></b-form-input>
                  </td> 

                  <td v-if = "selected_sub_catid !== 170">
                    <b-form-input
                      type="text"
                      class="requestageto"
                      name="requestageto"
                      v-model="selectedtoage[index]"
                      :key="index"
                      required
                      disabled
                      readonly
                    ></b-form-input>
                  </td>

                  <td v-if = "selected_sub_catid !== 170">
                    <b-form-input
                      type="text"
                      class="requestfactory"
                      name="factorysize"
                      v-model="factorysize[index]"
                      :key="index"
                      required
                      disabled
                      readonly
                    ></b-form-input>
                  </td>

                  <td v-if = "selected_sub_catid === 170">
                    <b-form-input
                      type="text"
                      class="requestuk"
                      name="uk"
                      v-model="uk[index]"
                      :key="index"
                      required
                      disabled
                      readonly
                    ></b-form-input>
                  </td>

                  <td v-if = "selected_sub_catid === 170">
                    <b-form-input
                      type="text"
                      class="requestus"
                      name="us"
                      v-model="us[index]"
                      :key="index"
                      required
                      disabled
                      readonly
                    ></b-form-input>
                  </td>

                  <td v-if = "selected_sub_catid === 170">
                    <b-form-input
                      type="text"
                      class="requestfootlengthcm"
                      name="foot_length_cm"
                      v-model="foot_length_cm[index]"
                      :key="index"
                      required
                      disabled
                      readonly
                    ></b-form-input>
                  </td>

                  <td v-if = "selected_sub_catid === 170">
                    <b-form-input
                      type="text"
                      class="requestbrandsizeeuro"
                      name="brand_size_euro"
                      v-model="brand_size_euro[index]"
                      :key="index"
                      required
                      disabled
                      readonly></b-form-input>

                  </td>
                  <td>
                    <b-form-input
                      class="requestquantity"
                      type="text"
                      name="quantity"
                      v-model="quantity[index]"
                      :key="index"
                      required
                      @change="
                        calculatetotal(quantity, index);
                        checkpattern(quantity[index]);
                      "
                      readonly
                      disabled
                    ></b-form-input>
                  </td>

                  <td >
                    <b-form-input
                      type="text"
                      class="requestmrp"
                      name="mrp"
                      v-model="total_mrp[index]"
                      :key="index"
                      required
                      disabled
                      readonly
                    ></b-form-input>
                  </td>
                   
                </tr>
              </tbody>
            </table>
          </b-row>
          <!-- New Code Added For Size Ends -->
          <!-- <b-row class="col-md-12">
          <b-col md="12">
              <button type="button"  class="btn btn-default tablebtn" style="color: #1b8eb7;font-size: 12px;" @click="opentable" >
              <i class="fa fa-table" aria-hidden="true"></i>&nbsp;TableSet</button> 
          </b-col>
        </b-row>
        <b-row class="col-md-12" v-if="temp_sizeset>0">
         <table class="table table-striped">
            <thead class="requestedhead">
              <tr>
                <td scope="col" >Size Set</td>                
                <td scope="col" >Unit</td>
                <td scope="col" >Age From</td>
                <td scope="col" >Age To</td>
                <td scope="col" >Factory Size(In CM )</td>
                <td colspan="2" scope="col" >Quantity</td>
              </tr>
            </thead>
            <tbody class="requestedbody">
              <tr v-for="(invoice_product, index) in sizeset">
                <td ><label class="requestsize">Size &nbsp;</label >{{index+1}}</td>
                
                <td >
                    <b-form-input type="text" class="selected_month" name="selected_month"   v-model="unit[index]" :key="index"  required disabled readonly></b-form-input> 
                    
                </td>

 

                <td >
                  <b-form-input type="text" class="selectedfromage" name="selectedfromage"   v-model="selectedfromage[index]" :key="index"  required disabled readonly></b-form-input>             
                </td>
                
                <td > 
                  
                  <b-form-input type="text" class="requestageto" name="requestageto"   v-model="selectedtoage[index]" :key="index"  required disabled readonly></b-form-input>
                </td>

                <td >
                  <b-form-input type="text" class="requestfactory" name="factorysize"   v-model="factorysize[index]" :key="index"  required disabled readonly></b-form-input>
                </td>

                <td >
                  <b-form-input class="requestquantity" type="text" name="quantity"   v-model="quantity[index]" :key="index"  required @change="calculatetotal(quantity,index); checkpattern(quantity[index])" readonly disabled></b-form-input>
                </td>
              </tr>
            </tbody>
          </table>
        </b-row> -->
          <!-- <b-row > -->
          <div
            style="margin-top:20px;text-align:right;"
            v-if="
              (user_type == 'Brand_Manager' &&
                style_details.operational_status == 'DH-approved' && 
                block_status != false) || (user_type == 'Buying_Head' && style_details.operational_status == 'FH-approved' && 
                block_status != false)
            "
          >
            <b-form
              data-vv-scope="form-5"
              @submit.prevent="updatestylestatus(comment, status)"
            >
              <div class="col-md-12">
                <b-form-group label="Remark" :label-cols="3">
                  <b-form-textarea
                    rows="3"
                    max-rows="6"
                    v-model="comment"
                    type="text"
                    name="comment"
                    class="col-md-12"
                    placeholder="Enter Comment Here..."
                  >
                  </b-form-textarea
                  ><br />
                  <b-input-group class="mb-3" style="float:right;">
                    <label class="radio-inline"
                      ><input
                        type="radio"
                        name="optradio"
                        value="approved"
                        v-model="status"
                        @click="selectGrade()"
                        checked
                      />&nbsp;Approved</label
                    >&nbsp;&nbsp;
                    <label class="radio-inline"
                      ><input
                        type="radio"
                        name="optradio"
                        value="rejected"
                        v-model="status"
                      />&nbsp;Reject</label
                    >&nbsp;&nbsp;
                    <label class="radio-inline"
                      ><input
                        type="radio"
                        name="optradio"
                        value="Feedback"
                        v-model="status"
                      />&nbsp;Feedback</label
                    >&nbsp;&nbsp;
                  </b-input-group>
                  <b-button
                    type="submit"
                    size="sm"
                    class="mr-4"
                    variant="primary"
                  >
                    Update Status</b-button
                  >
                </b-form-group>
              </div>
              <!-- <b-form-group
                  >
                  <div class="col-md-12 text-right" style="float: right;">
                  <div class="col-md-1"><label>Comment:</label></div>
                 <div class="col-md-11"><b-form-textarea  type="text"  rows="3" max-rows="6" v-model="comment" name="comment"  
                  placeholder="Enter Comment Here..." >
                  </b-form-textarea></div></div>
                  <div class="col-md-12" ><br><br>
                  <b-input-group >
                      <label class="radio-inline"><input type="radio" name="optradio" value="approved" v-model="status" checked>&nbsp;Approved</label>&nbsp;&nbsp;
                      <label class="radio-inline"><input type="radio" name="optradio" value="rejected" v-model="status">&nbsp;Reject</label>&nbsp;&nbsp;

                      <label class="radio-inline"><input type="radio" name="optradio" value="Feedback" v-model="status">&nbsp;Feedback</label>                       
                    &nbsp;&nbsp;
                    <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update Status</b-button>
                      </b-input-group>

                    </div>
                                 
                </b-form-group> -->
              <div class="col-md-12">
                <!-- <b-button  size="sm" variant="danger" @click="commentcancel()">cancel</b-button> -->
              </div>
            </b-form>

            <!-- <div slot="footer" class="text-right">
                  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update Status</b-button>
                  <b-button  size="sm" variant="danger" @click="commentcancel()">cancel</b-button>
                </div> -->
          </div>
          <!-- For buying head starts -->
<!-- <div
  style="margin-top:20px;text-align:right;"
  v-if="(user_type == 'Admin' || user_type == 'Design_Head' || user_type == 'Buying_Head')">
  <b-form
    data-vv-scope="form-5"
    @submit.prevent="updatestylestatus(comment, status)"
  >
    <div class="col-md-12">
      <b-form-group label="Remark2" :label-cols="3">
        <b-form-textarea
          rows="3"
          max-rows="6"
          v-model="comment"
          type="text"
          name="comment"
          class="col-md-12"
          placeholder="Enter Comment Here..."
        >
        </b-form-textarea
        ><br />
        <b-input-group class="mb-3" style="float:right;">
          <label class="radio-inline"
            ><input
              type="radio"
              name="optradio"
              value="approved"
              v-model="status"
              @click="selectGrade()"
              checked
            />&nbsp;Approved</label
          >&nbsp;&nbsp;
          <label class="radio-inline" 
            ><input
              type="radio"
              name="optradio"
              value="rejected"
              v-model="status"
            />&nbsp;Reject</label
          >&nbsp;&nbsp;
          <label class="radio-inline"
            ><input
              type="radio"
              name="optradio"
              value="Feedback"
              v-model="status"
            />&nbsp;Feedback</label
          >&nbsp;&nbsp;
        </b-input-group>
        <b-button
          type="submit"
          size="sm"
          class="mr-4"
          variant="primary"
        >
          Update Status</b-button
        >
      </b-form-group>
    </div>

    <div class="col-md-12">
    
    </div>
  </b-form>
  
</div> -->
          <!-- </b-row> -->
          <!-- </b-card> -->
          <!-- </div> -->

          <!-- </div> -->
          <!-- <b-row class="col-md-12">
          <b-col md="12">
              <button type="button"  class="btn btn-default tablebtn" style="color: #1b8eb7;font-size: 12px;" @click="opentable" >
              <i class="fa fa-table" aria-hidden="true"></i>&nbsp;TableSet</button> 
          </b-col>
        </b-row> -->
        </div>
      </div>

      <!-- Table Modal for small -->
      <b-modal
        id="modal-lg"
        size="xl"
        title="Table Set"
        v-model="opentablemodel"
        @ok="opentablemodel = false"
      >
        <template slot="modal-header">
          <h5>Table Set</h5>
        </template>
        <!-- <template slot="default" slot-scope="{ hide }">
            <div>
              Hiiiiiiiiii
            </div>
          </template> -->
        <!-- <b-button  size="sm"  @click="openimagecancel()" style="background: none; border: none;"><i class="fa fa-close"></i></b-button>
          </template> -->

        <template slot="modal-footer" slot-scope="{ hide }">
          <b-button size="sm" style="display:none">
            Cancel
          </b-button>
        </template>
      </b-modal>

      <!-- Image Zoom Model -->
      <b-modal
        id="modal-lg"
        size="lg"
        title="Image Zoom"
        v-model="openimagemodel"
        @ok="openimagemodel = false"
      >
        <template slot="modal-header">
          <h5>Zoom Image</h5>
          <b-button
            size="sm"
            @click="openimagecancel()"
            style="background: none; border: none;"
            ><i class="fa fa-close"></i
          ></b-button>
        </template>
        <template slot="default" slot-scope="{ hide }">
          <div id="btn_navbar">
            <button type="button" class="btn btn-success" @click="zoomin()">
              <i class="fa fa-search-plus" aria-hidden="true"
                >&nbsp;Zoom In</i
              ></button
            >&nbsp;
            <button type="button" class="btn btn-danger" @click="zoomout()">
              <i class="fa fa-search-minus" aria-hidden="true"
                >&nbsp;Zoom Out</i
              >
            </button>
            <button
              type="button"
              class="btn btn-info m-2"
              @click="showMagnifier()"
            >
              <i class="fa fa-search" aria-hidden="true"
                >&nbsp;Magnifier Glass</i
              >
            </button>
          </div>

          <div class="main1" style="text-align: center;">
            <!-- <img v-bind:src="style_details.style_image" id="map" height="220" width="270" style="padding:5px;"/> -->
            <div
              v-if="finalImageType == 'image'"
              class="img-magnifier-container"
              style="padding:2px;"
            >
              <img
                v-bind:src="finalImage"
                id="map"
                style="padding:5px;width:100%;height:100%;"
              />
            </div>
            
            <div v-if="finalImageType == 'other'">
              <vue-pdf-embed
                :source="finalImage"
                id="map"
                height="220"
                width="270"
                style="padding:5px;"
              />
            </div>
          </div>

          <div slot="footer" class="text-right">
            <!--  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button> -->
            <b-button size="sm" variant="danger" @click="openimagecancel()"
              >cancel</b-button
            >
          </div>
        </template>
        <template slot="modal-footer" slot-scope="{ hide }">
          <b-button size="sm" style="display:none">
            Cancel
          </b-button>
        </template>
      </b-modal>
      <!-- Image Zoom Model -->

      <!-- Art work Image Zoom Model -->
      <b-modal
        id="modal-lg"
        size="lg"
        title="Image Zoom"
        v-model="openartworkimagemodel"
        @ok="openartworkimagemodel = false"
      >
        <template slot="modal-header">
          <h5>Zoom Image</h5>
          <b-button
            size="sm"
            @click="openartworkimagecancel()"
            style="background: none; border: none;"
            ><i class="fa fa-close"></i
          ></b-button>
        </template>
        <template slot="default" slot-scope="{ hide }">
          <div id="btn_navbar">
            <button type="button" class="btn btn-success" @click="zoomin()">
              <i class="fa fa-search-plus" aria-hidden="true"
                >&nbsp;Zoom In</i
              ></button
            >&nbsp;
            <button type="button" class="btn btn-danger" @click="zoomout()">
              <i class="fa fa-search-minus" aria-hidden="true"
                >&nbsp;Zoom Out</i
              >
            </button>
            <button
              type="button"
              class="btn btn-info m-2"
              @click="showMagnifier()"
            >
              <i class="fa fa-search" aria-hidden="true"
                >&nbsp;Magnifier Glass</i
              >
            </button>
          </div>

          <div class="main1" style="text-align: center;">
            <!-- <img v-bind:src="style_details.style_image" id="map" height="220" width="270" style="padding:5px;"/> -->

            <img
              v-bind:src="style_details.artwork_image"
              id="map"
              style="width:50px;height:50px;"
            />
          </div>

          <div slot="footer" class="text-right">
            <!--  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button> -->
            <b-button
              size="sm"
              variant="danger"
              @click="openartworkimagecancel()"
              >cancel</b-button
            >
          </div>
        </template>
        <template slot="modal-footer" slot-scope="{ hide }">
          <b-button size="sm" style="display:none">
            Cancel
          </b-button>
        </template>
      </b-modal>
      <!-- Art work Image Zoom Model -->

      <!-- Code For Edit Design -->
      <b-modal
        size="xl"
        title="Edit Style Details"
        v-model="editdesign"
        @ok="editdesign = false"
      >
        <template slot="modal-header">
          <h5>Edit Style Details</h5>
          <button
            type="button"
            class="close"
            aria-label="Close"
            slot-scope="{ hide }"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </template>
        <template slot="default" slot-scope="{ hide }">
          <b-form
            name="styleform"
            @submit.prevent="updatestyle('styleform', 0)"
            @reset.prevent="updatestyle('styleform', 1)"
            data-vv-scope="form-5"
          >
            <!-- <b-col cols="4" > -->
            <div
              style="float: left;
                  border: 1px solid lightgray;"
            >
              <div>
                <img
                  v-bind:src="sytleImageurl || sampleImageurl"
                  height="200"
                  width="270"
                  style="padding:5px;"
                />

                <!-- <img
                  v-bind:src="sytleImageurl"
                  height="200"
                  width="270"
                  style="padding:5px;"
                /> -->
              </div>
              <!-- <b-form-group style="margin-top:25px;">
                <b-form-file
                  v-model="file"
                  :state="Boolean(file)"
                  placeholder="Upload Design File"
                  accept=".pdf,.png,.jpeg,.jpg"
                  @change="AddDesignimagedraft($event)"
                ></b-form-file>
              </b-form-group> -->

              <b-form-group style="margin-top:25px;">
              <div 
                class="drag-drop-zone"
                :class="{ 'drag-over': isDraggingDesign }"
                @dragenter.prevent="handleDragEnterDesign"
                @dragover.prevent="handleDragOverDesign"
                @dragleave.prevent="handleDragLeaveDesign"
                @drop.prevent="handleDropDesign"
              >
                <div class="drag-drop-content">
                  <i class="fa fa-cloud-upload fa-3x mb-3" style="color: #20a8d8;"></i>
                  <p class="mb-2"><strong>Drag & Drop design file here</strong></p>
                  <p class="text-muted mb-3">or</p>

                  <b-form-file
                    ref="designFileInput"
                    v-model="file"
                    :state="Boolean(file)"
                    placeholder="Upload Design File"
                    accept=".pdf,.png,.jpeg,.jpg"
                    @change="AddDesignimagedraft($event)"
                  ></b-form-file>
                </div>
              </div>
            </b-form-group>

              <!-- previewImage -->
              <!-- Code For Progress Bar -->
              <div
                class="progress"
                id="progress_bar"
                style="display:none; margin-top: 5px; margin-bottom: 5px; width: 100%; height: 30px;font-size: 18px; font-weight: bold;"
              >
                <div
                  class="progress-bar progress-bar-info progress-bar-striped"
                  role="progressbar"
                  :aria-valuenow="progress"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  :style="{
                    height: '30px',
                    text: '20px',
                    align: 'center',
                    width: progress + '%',
                  }"
                >
                  {{ progress }}%
                </div>
              </div>
              <!-- Code For Progress Bar Ends -->
            </div>
            <!-- {{style_details}} -->
            <div style="margin-left:40%">
              <b-form-group label="Style Name" :label-cols="4" class="m-0 p-1">
                <b-form-input
                  type="text"
                  name="style_name"
                  v-model="style_details.style_name"
                  placeholder="Enter Style Name"
                  required
                  readonly
                  disabled
                >
                </b-form-input>
              </b-form-group>

              <b-form-group label="Story Name" :label-cols="4"  class="m-0 p-1">
                <b-form-input
                  type="text"
                  name="story_name"
                  v-model="style_details.story_name"
                  placeholder="Enter Story Name"
                  required
                >
                </b-form-input>
              </b-form-group>
              <b-form-group label="Select Panton Type" :label-cols="4" class="m-0 p-1">
                <b-form-select
                  list="family-list-id"
                  v-model="selected_panton_type"
                  placeholder="Select Panton Type"
                  @change="
                    colortypecheck(selected_panton_type);
                    getselectedfamilycolor(selected_panton_type);
                  "
                >
                  <option value="">--Select--</option>
                  <option value="TPG">TPG</option>
                  <option value="TCX">TCX</option>
                  <option value="OTHERS">OTHERS</option></b-form-select
                >
              </b-form-group>
              <div v-if="selected_panton_type != 'OTHERS'">
                <b-form-group class="m-0 p-1"
                  label="Select Panton Color"
                  :label-cols="4"
                  id="pantom_color_block"
                >
                  <v-select required
                    id="mySelect"
                    v-model="pantone_color"
                    :options="color_name"
                    name="selected_pantone_no"
                    list="list"
                    @change="
                      setSelectedcolor(pantone_color, 1);
                    "
                    placeholder="Select Panton Color"
                  >
                  </v-select>
                </b-form-group>

               <b-form-group label="Selected Color " class="m-0 p-1"
                  :label-cols="4" id="selectedcolor">
                  
                  <div md="6" v-for="(color,index) in selected_final_color" class="d-flex flex-flow justify-content-between border m-1 p-1" :style="`background-color:${color.split(' ').pop()};`" :id="'color'+index">
                  <span>{{color}}</span> <i class="fa fa-close" @click="()=>removecolor(index)"></i>
                  </div>
                

                  <div class="m-1 p-1 d-flex flex-flow justify-content-between border" v-for="(colors,index) in selected_mutlicolor" :style="`background-color:${colors.split(' ').pop()}`" :id="'colors'+index">
                      {{ colors }}  <i class="fa fa-close" @click="()=>removeselectedcolor(index)"></i>

                  </div>


                </b-form-group>
              </div>
              <b-form-group class="m-0 p-1"
                label="Color"
                :label-cols="4"
                id="other_value_block"   
                style="display:none;"       
              >
                <b-form-input
                  type="text"
                  name="color"
                  v-model="otherColor"
                  placeholder="Enter Color Name"
                >
                </b-form-input>
              </b-form-group>
              <b-form-group class="m-0 p-1"
                label="Color"
                :label-cols="4"
                v-if="style_details.panton_type == 'OTHERS' && selected_panton_type == 'OTHERS'"     
              >
                <b-form-input
                  type="text"
                  name="color"
                  v-model="otherColor"
                  placeholder="Enter Color Name"
                >
                </b-form-input>
              </b-form-group>


              <b-form-group label="Style Type" :label-cols="4" class="m-0 p-1">
                 <b-form-select id="selected_style_type" name="selected_style_type" v-model="selected_style_type" :options="optionsstyletype"></b-form-select>
              </b-form-group>

              <b-form-group label="Upper material" :label-cols="4" v-if = "selected_sub_catid === 170">
                <b-form-select placeholder="Select" v-model="upper_material"
                required
                  class="input">
                    <option value="">--Select--</option>
                    <option value="pu">PU</option>
                    <option value="pvc">PVC</option>
                    <option value="eva">EVA</option>
                    <option value="fabric">Fabric</option>
                    <option value="canvas">Canvas</option>
                    <option value="cotton">Cotton</option>
                    <option value="synthetic">Synthetic</option>
                    <option value="velvet">Velvet</option>
                    <option value="suede">Suede</option>
                    <option value="satin">Satin</option>
                    <option value="mesh">Mesh</option>
                    <option value="denim">Denim</option>
                    <option value="sequins Fabric">sequins Fabric</option>
                    <option value="glitter coated pu">Glitter coated PU</option>
                    <option value="knitted">Knitted</option>
                </b-form-select>
              </b-form-group>

              <b-form-group label="Inner Lining" :label-cols="4" v-if = "selected_sub_catid === 170">
                <b-form-select placeholder="Select" v-model="inner_lining"
                required
                  class="input">
                    <option value="">--Select--</option>
                    <option value="synthetics">Synthetics</option>
                    <option value="wool">Wool</option>
                    <option value="satin">Satin</option>
                    <option value="suede">Suede</option>
                    <option value="poplin">Poplin</option>
                    <option value="cotton polyester">Cotton Polyester</option>
                    <option value="polyester">Polyester</option>
                    <option value="pvc">PVC</option>
                    <option value="eva">EVA</option>
                    <option value="unlined">Unlined</option>
                    <option value="pu">PU</option>
                </b-form-select>
              </b-form-group> 

              <b-form-group label="Sole" :label-cols="4" v-if = "selected_sub_catid === 170">
                <b-form-select placeholder="Select" v-model="sole"
                required
                  class="input">
                    <option value="">--Select--</option> 
                    <option value="tpr">TPR</option>
                    <option value="pu">PU</option>
                    <option value="rubber">Rubber</option>
                    <option value="eva">EVA</option>
                    <option value="tpu">TPU</option>
                    <option value="rubberized cork">Rubberized Cork</option>
                    <option value="phylon">Phylon</option>
                    <option value="thunit">Thunit</option>
                    <option value="pu mix">PU Mix</option>
                    <option value="rubber mix">Rubber Mix</option>
                </b-form-select>
              </b-form-group>

              <b-form-group label="Surface Ornamentation" :label-cols="4" v-if = "selected_sub_catid === 170">
                <b-form-select placeholder="Select" v-model="surface_ornamentation"
                  required
                  class="input">
                    <option value="">--Select--</option>
                    <option value="frill">Frill</option>
                    <option value="sequins">Sequins</option>
                    <option value="embellishment">Embellishment</option>
                    <option value="ruffles">Ruffles</option>
                    <option value="tassels">Tassels</option>
                    <option value="reverse stripes">Reverse Stripes</option>
                    <option value="tape">Tape</option>
                    <option value="shoe charms">Shoe Charms</option>
                    <option value="Printed">Printed</option>
                    <option value="Applique">Applique</option>
                    <option value="Embroidery">Embroidery</option>
                    <option value="Texture Print">Texture Print</option>
                    <option value="Quilted">Quilted</option>
                    <option value="Trim">Trim</option>
                    <option value="Buckle"> Buckle</option>
                    <option value="Bow">Bow</option>
                    <option value="NA">NA</option>
                </b-form-select>
              </b-form-group>

              <b-form-group label="Highlight" :label-cols="4" v-if = "selected_sub_catid === 170">
                <b-form-select placeholder="Select" v-model="highlight"
                required
                  class="input">
                    <option value="">--Select--</option>
                    <option value="color block">Color block</option>
                    <option value="accent detailing">Accent detailing</option>
                    <option value="light weight">Light weight</option>
                    <option value="soft & flexible">Soft & flexible</option>
                    <option value="color changing">Color changing</option>
                    <option value="Vibrant print">Vibrant print</option>
                    <option value="Floral Appliqu">Floral Applique</option>
                    <option value="Shiny upper">Shiny upper</option>
                    <option value="Bow Detail">Bow Detail</option>
                    <option value="Saddle">Saddle</option>
                    <option value="Glittering applique">Glittering applique</option>
                    <option value="Glittering upper">Glittering upper</option>
                    <option value="Water Proof">Water Proof</option>
                    <option value="Washable">Washable</option>
                    <option value="Braided detailing"> Braided detailing</option>
                    <option value="Interlaced detailing">Interlaced detailing</option>
                    <option value="Breathable">Breathable</option>
                    <option value="Reflective detailing">Reflective detailing</option>
                    <option value="Non Marking Sole"> Non Marking Sole</option>
                    <option value="Ankle Support">Ankle Support</option>
                    <option value="Dual Density Sole">Dual Density Sole</option>
                    <option value="Studded Sole">Studded Sole</option>
                    <option value="All terrain Shoes">All terrain Shoes</option>
                    <option value="Arch Support">Arch Support</option>
                    <option value="orthopedic footbed">Orthopedic Footbed</option>
                </b-form-select>
              </b-form-group>
  
              <b-form-group label="Fastening Type" :label-cols="4" v-if = "selected_sub_catid === 170">
                <b-form-select placeholder="Select" v-model="Fastening_type"
                required
                  class="input">
                    <option value="">--Select--</option>
                    <option value="slip-on">Slip-On</option>
                    <option value="lace-up">Lace-Up</option>
                    <option value="buckle">Buckle</option>
                    <option value="zip">Zip</option>
                    <option value="elastic">Elastic</option>
                    <option value="velcro">Velcro</option>
                    <option value="velcro+Elastic">Velcro + Elastic</option>
                    <option value="snap button">Snap Button</option>
                </b-form-select>
              </b-form-group>

              <b-form-group  label="Fabric Type" :label-cols="4" v-if= "selected_sub_catid !== 170">
                <b-form-select v-model="fabrictype" id="fabrictype" name="fabrictype"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.fabrictype') }">
                      <!-- <option :value="selected" >Select Option</option> -->
                      <option value="knit">Knit</option>
                      <option value="woven">Woven</option>
                    </b-form-select> 
              
                    <b-input-group >
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('fabrictype')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.fabrictype')" id="statustxt" class="help text-danger">{{ errors.first('form-5.fabrictype') }}
                      </code>
                    </b-input-group>
              </b-form-group>

              <b-form-group label="Material" :label-cols="4" v-if= "selected_sub_catid !== 170">
                 <b-form-select v-model="material" id="material" name="material"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.material') }">
                  <option :value="selected" >Select Option</option>
                  <option :value="fabrictype_list.title" v-for="fabrictype_list in fabrictype_arr">{{ fabrictype_list.title }}</option>
                 </b-form-select> 
              </b-form-group>

                <b-form-group label="Top Fabric Type"  :label-cols="4" v-if= "selected_sub_catid !== 170">
                  <b-form-select v-model="topfabrictype" id="topfabrictype" name="topfabrictype" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.topfabrictype') }">
                    <!-- <option :value='null' >Select Option</option> -->
                    <option :value="topfabrictype.title" v-for="topfabrictype in top_fabric_arr">{{ topfabrictype.title }}</option>
                  </b-form-select> 
                </b-form-group>
                <b-form-group  label="Bottom Fabric Type" :label-cols="4"  v-if= "selected_sub_catid !== 170">
                  <b-form-select v-model="bottomfabrictype" id="bottomfabrictype" name="bottomfabrictype" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.bottomfabrictype') }">
                    <!-- <option :value='null' >Select Option</option> -->
                    <option :value="bottomfabrictype.title" v-for="bottomfabrictype in top_fabric_arr">{{ bottomfabrictype.title }}</option>
                  </b-form-select> 
            
                </b-form-group>

              <!-- {{style_details.pack_of}} -->
               <b-form-group label="Pack Of" :label-cols="4" v-if= "selected_sub_catid !== 170">
                <b-form-select v-model="pack_of" id="pack_of" name="pack_of"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.pack_of') }">
                  <option :value="selected" >Select Option</option>
                  <option :value="1" >Single</option>
                  <option v-for="pack in Array.from({ length: 10 - 2 + 1 }, (_, i) => i + 2)" :value="pack">Pack of {{pack}}</option>
                </b-form-select> 
                <b-input-group>
                  <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('pack_of')" ></i>
                  </span>
                  <code v-show="errors.has('form-5.pack_of')" id="pack_of" class="help text-danger">{{ errors.first('form-5.pack_of') }}
                  </code>
                </b-input-group>
              </b-form-group>

               <b-form-group label="EPP" :label-cols="4">
                <b-form-select v-model="is_epp" id="is_epp" name="is_epp"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.is_epp') }">
                  <option :value="selected" >Select Option</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </b-form-select> 
                <b-input-group >
                  <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('is_epp')" ></i>
                  </span>
                  <code v-show="errors.has('form-5.is_epp')" id="is_epp" class="help text-danger">{{ errors.first('form-5.is_epp') }}
                  </code>
                </b-input-group>
              </b-form-group>

               <b-form-group label="Style Comment" :label-cols="4">
                <b-form-textarea
                    type="text"
                    name="Comment"
                    v-model="style_comment"
                    placeholder="Enter Style Comment"
                    required
                >
                <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('Comment')" ></i>
                    </span>
                    <code v-show="errors.has('form-5.Comment')" id="Comment" class="help text-danger">{{ errors.first('form-5.Comment') }}
                    </code>
                </b-form-textarea>
                </b-form-group>

              <b-form-group label="PO Type" :label-cols="4" class="m-0 p-1">
              
                <b-form-select disabled
                  v-model="selected_po_id"
                  id="selected_po_id"
                  name="selected_po_id"
                >
                  <option :value="selected">--Select--</option>
                  <option v-for="polist in po_typearr" :value="polist.po_id">{{
                    polist.potype_title
                  }}</option>
                </b-form-select>
              </b-form-group>
              <!-- <b-form-group label="Sample Image" :label-cols="4" class="m-0 p-1">
                <b-form-file
                  v-model="file1"
                  :state="Boolean(file1)"
                  placeholder="Upload Sample Image"
                  accept="image/*"
                  @change="AddSampleimage($event)"
                ></b-form-file>
              </b-form-group> -->

               <b-form-group
              label="Sample Image"
              :label-cols="4" >

              <div 
              class="drag-drop-zone"
              :class="{ 'drag-over': isDraggingSample }"
              @dragenter.prevent="handleDragEnterSample"
              @dragover.prevent="handleDragOverSample"
              @dragleave.prevent="handleDragLeaveSample"
              @drop.prevent="handleDropSample">
              <div class="drag-drop-content">
                <i class="fa fa-cloud-upload fa-3x mb-3" style="color: #20a8d8;"></i>
                <p class="mb-2"><strong>Drag and drop sample image here</strong></p>
                <p class="text-muted mb-3">or</p>

                <!-- File Browse -->
                <b-form-file
                  ref="sampleFileInput"
                  v-model="file1"
                  :state="Boolean(file1)"
                  placeholder="Click to browse"
                  accept="image/*"
                  @change="AddSampleimage($event)"
                  class="d-inline-block"
                  style="max-width: 200px;"
                ></b-form-file>
              </div>
            </div>       
                </b-form-group>

              <!-- Added Code for Size Set Ends -->
              <!-- New Code Added For Size Set -->
              <!--  <b-form-group label="Size Range" :label-cols="3" >
              <b-row id="size_range" >
              <b-col sm="4" style="display: inline-flex;">
              <b-form-select class="fileunit" :plain="true" name="selected_month" required v-model="range_selected_month" :options="unit_arr"  @change="range_changeMonthYearVal($event)" style="width: 90px;">
              </b-form-select>
            </b-col>
            <b-col sm="4"  style="display: inline-flex;">
              <b-form-select class="filefromage" v-if="range_selected_month ==null"  :plain="true" name="range_selectedfromage" v-model="range_selectedfromage"  required :options="agefrmto_default" :class="{'input': true, 'text-danger': errors.has('selectedfromage[index]') }" selected >
              </b-form-select>
         
  
              <b-form-select class="filefromage" v-if="range_selected_month =='0'" :plain="true" name="selectedfromage"  v-model="range_selectedfromage" required :options="month_arr" :class="{'input': true, 'text-danger': errors.has('selectedfromage[index]') }"  >
              </b-form-select>

              
              <b-form-select class="filefromage" v-if="range_selected_month =='1'"  :plain="true" name="selectedfromage"  v-model="range_selectedfromage" required :options="year_arr" :class="{'input': true, 'text-danger': errors.has('selectedfromage[index]') }"  >
              </b-form-select>
            </b-col>
            <b-col sm="4" style="display: inline-flex;">
              <b-form-select class="filetoage" v-if="range_selected_month ==null"   :plain="true" v-model="range_selectedtoage" :options="agefrmto_default"  required>
              </b-form-select> 

              <b-form-select class="filetoage" v-if="range_selected_month =='0'"   :plain="true" v-model="range_selectedtoage" :options="to_month_arr"  required >
              </b-form-select> 

              <b-form-select class="filetoage" v-if="range_selected_month =='1'"   :plain="true" v-model="range_selectedtoage" :options="to_year_arr"  required >
              </b-form-select>
            </b-col>
            
            
            <b-col sm="12" style="text-align: right; margin-top: 4px"><b-button type="button" size="sm" class="mr-4 pull-right text-right" variant="primary" style="float: right;" @click="setsizeset(range_selected_month,range_selectedfromage,range_selectedtoage)" v-if="range_selectedtoage!=0 && range_selectedfromage!=0">Go</b-button></b-col>
            </b-row>
          </b-form-group> -->

              <!-- <div  class="col-md-12" id="sizesetData">
              
              <b-row style="overflow:auto">
                <b-form class="col-md-12" data-vv-scope="form-5">
              
                  <table class="table table-striped ">
                    <thead>
                      <tr class="fileshead">
                        <td scope="col">Size Set</td>
                        <td scope="col">Unit</td>
                        <td scope="col">Age From</td>
                        <td scope="col">Age To</td>
                      </tr>
                    </thead>
                    <tbody class="filesbody">
                      <tr v-for="(invoice_product, index) in sizeset">
                        <td class="filesize"><label >Size &nbsp;</label>{{index+1}}</td>
                        <td>
                            <b-form-select class="fileunit" :plain="true" name="selected_month" required v-model="selected_month[index]" :options="unit_arr"  @change="changeMonthYearVal($event,index)">
                            </b-form-select>
                            
                        </td>

         

                        <td>
                          <b-form-select class="filefromage" v-if="selected_month[index] ==null"  :plain="true" name="selectedfromage"  required :options="agefrmto_default" :class="{'input': true, 'text-danger': errors.has('selectedfromage[index]') }" selected >
                          </b-form-select>
                          <b-form-select class="filefromage" v-if="selected_month[index] =='0'" :plain="true" name="selectedfromage"  v-model="selectedfromage[index]" required :options="month_arr" :class="{'input': true, 'text-danger': errors.has('selectedfromage[index]') }"  >
                          </b-form-select>
                          <b-form-select class="filefromage" v-if="selected_month[index] =='1'"  :plain="true" name="selectedfromage"  v-model="selectedfromage[index]" required :options="year_arr" :class="{'input': true, 'text-danger': errors.has('selectedfromage[index]') }"  >
                          </b-form-select>               
                        </td>
                        
                        <td > 
                          <b-form-select class="filetoage" v-if="selected_month[index] ==null"   :plain="true" v-model="selectedtoage[index]" :options="agefrmto_default"  required>
                          </b-form-select> 
                          <b-form-select class="filetoage" v-if="selected_month[index] =='0'"   :plain="true" v-model="selectedtoage[index]" :options="to_month_arr"  required @change="checkagevalue(selectedfromage[index],selectedtoage[index], index)">
                          </b-form-select> 
                          <b-form-select class="filetoage" v-if="selected_month[index] =='1'"   :plain="true" v-model="selectedtoage[index]" :options="to_year_arr"  required @change="checkagevalue(selectedfromage[index],selectedtoage[index], index); ">
                          </b-form-select>

                          <b-input-group class="mb-3">
                              <span class="icon has-text-warning">
                                <i class="fa fa-warning" v-show="errors.has('selectedtoage')" ></i>
                              </span>
                              <code v-show="errors.has('form-5.selectedtoage')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.selectedtoage') }}
                              </code>
                          </b-input-group>

                        </td>

                       
                      </tr>
                    </tbody>

                  </table>
         
                </b-form>
                  </b-row>
                    
            </div> -->
              <!-- New Code Added For Size set -->

              <b-form-group label="Style Description" :label-cols="4" class="m-0 p-1">
                <b-form-input
                  type="text"
                  name="style_description"
                  v-model="style_details.style_description"
                  placeholder="Enter Style Description"
                  required
                >
                </b-form-input>
                <!-- <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('style_description')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.style_description')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.style_description') }}
                      </code>
                      </b-input-group> -->
              </b-form-group>

              <div slot="footer" class="text-right">
                <b-button
                  type="reset"
                  size="sm"
                  class="mr-4"
                  variant="secondary"
                  v-if="style_details.is_draft == 1"
                  >Draft Save</b-button
                >
                <b-button
                  type="submit"
                  size="sm"
                  class="mr-4"
                  variant="primary"
                >
                  Update</b-button
                >
                <!-- Code For Progress Bar -->
                <div class="progress1" id="progress_bar1" style="display:none;">
                  <div
                    class="progress-bar progress-bar-info progress-bar-striped"
                    role="progressbar"
                    :aria-valuenow="progress"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    :style="{
                      height: '30px',
                      text: '20px',
                      align: 'center',
                      width: progress + '%',
                    }"
                  >
                    {{ progress1 }}%
                  </div>
                </div>
                <!-- Code For Progress Bar Ends -->
                <b-button size="sm" variant="danger" @click="editdesigncancel()"
                  >cancel</b-button
                >
              </div>
            </div>
          </b-form>
        </template>
        <template slot="modal-footer" slot-scope="{ hide }">
          <b-button size="sm" style="display:none">
            Cancel
          </b-button>
        </template>
      </b-modal>
      <!-- Code For Edit Design Ends -->

    <!-- Delete style Modal -->
      <b-modal title="Delete Style" v-model="showDeleteStyleModel" @ok="showDeleteStyleModel = false" size="xs">
        <h5>Are you sure you want to delete this style?</h5>

        <template slot="default">
          <div slot="footer" class="text-right mt-5">
              <b-button size="xs" type="submit" variant="danger" @click="deleteStyleData(style_details.style_id)"
              >Delete</b-button
            >
            <b-button size="xs" class="ml-2" variant="dark" @click="closedeletemodal()"
              >Cancel</b-button
            >
          </div>
        </template>
      </b-modal>

    <!-- Close Delete modal -->

    <!-- Code For EDIT DESIGN DETAILS -->
      <b-modal
        title="Edit Design Details"
        v-model="designDetailsModel"
        @ok="designDetailsModel = false"
        size="lg"
      >
        <h5>Edit Design Details</h5>

        <template slot="default" slot-scope="{ hide }">
          <b-form  name="updatedata" @submit.prevent="validateUpdateDesignDetails('updatedata')" >
            <b-row>
              <b-col md="4">
                <label>Style Name</label>
                <input class="form-control" disabled v-model="style_details.style_name" />
              </b-col>
              <b-col md="4">
                <label>Style Code</label>
                <input class="form-control" disabled v-model="style_details.style_code" />
              </b-col>
              <b-col md="4">
                <label>Story Name</label>
                <input class="form-control" v-model="style_details.story_name" />
              </b-col>
             
              <!-- <b-col md="4" class="mt-2">
                <label>Design Hit</label>
                <input class="form-control" v-model="style_details.design_hit " placeholder="Enter details" />
              </b-col> -->
              <b-col md="4" class="mt-2">
                <label>Style Description</label>
                <input class="form-control" v-model="style_details.style_description" />
              </b-col>
              <b-col md="4" class="mt-2">
                <label>Style Type</label>
                <b-form-group>
                  <b-form-select id="selected_style_type" name="selected_style_type" v-model="selected_style_type" :options="optionsstyletype"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="4" class="mt-2" v-if = "selected_sub_catid === 170">
               <label>Upper material</label>
               <b-form-group>
                <b-form-select placeholder="Select" v-model="upper_material"
                required
                  class="input">
                    <option value="">--Select--</option>
                    <option value="pu">PU</option>
                    <option value="pvc">PVC</option>
                    <option value="eva">EVA</option>
                    <option value="fabric">Fabric</option>
                    <option value="canvas">Canvas</option>
                    <option value="cotton">Cotton</option>
                    <option value="synthetic">Synthetic</option>
                    <option value="velvet">Velvet</option>
                    <option value="suede">Suede</option>
                    <option value="satin">Satin</option>
                    <option value="mesh">Mesh</option>
                    <option value="denim">Denim</option>
                    <option value="sequins Fabric">sequins Fabric</option>
                    <option value="glitter coated pu">Glitter coated PU</option>
                    <option value="knitted">Knitted</option>
                </b-form-select>
              </b-form-group>
              </b-col>

              <b-col md="4" class="mt-2" v-if = "selected_sub_catid === 170">
                <label>Inner Lining</label>
              <b-form-group>
                <b-form-select placeholder="Select" v-model="inner_lining"
                required
                  class="input">
                    <option value="">--Select--</option>
                    <option value="synthetics">Synthetics</option>
                    <option value="wool">Wool</option>
                    <option value="satin">Satin</option>
                    <option value="suede">Suede</option>
                    <option value="poplin">Poplin</option>
                    <option value="cotton polyester">Cotton Polyester</option>
                    <option value="polyester">Polyester</option>
                    <option value="pvc">PVC</option>
                    <option value="eva">EVA</option>
                    <option value="unlined">Unlined</option>
                    <option value="pu">PU</option>
                </b-form-select>
              </b-form-group> 
            </b-col>

              <b-col md="4" class="mt-2" v-if = "selected_sub_catid === 170 ">
                <label>Sole</label>
              <b-form-group>
                <b-form-select placeholder="Select" v-model="sole"
                required
                  class="input">
                    <option value="">--Select--</option> 
                    <option value="tpr">TPR</option>
                    <option value="pu">PU</option>
                    <option value="rubber">Rubber</option>
                    <option value="eva">EVA</option>
                    <option value="tpu">TPU</option>
                    <option value="rubberized cork">Rubberized Cork</option>
                    <option value="phylon">Phylon</option>
                    <option value="thunit">Thunit</option>
                    <option value="pu mix">PU Mix</option>
                    <option value="rubber mix">Rubber Mix</option>
                </b-form-select>
              </b-form-group>
              </b-col>

              <b-col md="4" class="mt-2" v-if = "selected_sub_catid === 170">
                <label>Surface Ornamentation</label>
              <b-form-group>
                <b-form-select placeholder="Select" v-model="surface_ornamentation"
                  required
                  class="input">
                    <option value="">--Select--</option>
                    <option value="frill">Frill</option>
                    <option value="sequins">Sequins</option>
                    <option value="embellishment">Embellishment</option>
                    <option value="ruffles">Ruffles</option>
                    <option value="tassels">Tassels</option>
                    <option value="reverse stripes">Reverse Stripes</option>
                    <option value="tape">Tape</option>
                    <option value="shoe charms">Shoe Charms</option>
                    <option value="Printed">Printed</option>
                    <option value="Applique">Applique</option>
                    <option value="Embroidery">Embroidery</option>
                    <option value="Texture Print">Texture Print</option>
                    <option value="Quilted">Quilted</option>
                    <option value="Trim">Trim</option>
                    <option value="Buckle"> Buckle</option>
                    <option value="Bow">Bow</option>
                    <option value="NA">NA</option>
                </b-form-select>
              </b-form-group>
              </b-col>


              <b-col md="4" class="mt-2" v-if = "selected_sub_catid === 170 ">
                <label>Highlight</label>
              <b-form-group>
                <b-form-select placeholder="Select" v-model="highlight"
                required
                  class="input">
                    <option value="">--Select--</option>
                    <option value="color block">Color block</option>
                    <option value="accent detailing">Accent detailing</option>
                    <option value="light weight">Light weight</option>
                    <option value="soft & flexible">Soft & flexible</option>
                    <option value="color changing">Color changing</option>
                    <option value="Vibrant print">Vibrant print</option>
                    <option value="Floral Appliqu">Floral Applique</option>
                    <option value="Shiny upper">Shiny upper</option>
                    <option value="Bow Detail">Bow Detail</option>
                    <option value="Saddle">Saddle</option>
                    <option value="Glittering applique">Glittering applique</option>
                    <option value="Glittering upper">Glittering upper</option>
                    <option value="Water Proof">Water Proof</option>
                    <option value="Washable">Washable</option>
                    <option value="Braided detailing"> Braided detailing</option>
                    <option value="Interlaced detailing">Interlaced detailing</option>
                    <option value="Breathable">Breathable</option>
                    <option value="Reflective detailing">Reflective detailing</option>
                    <option value="Non Marking Sole"> Non Marking Sole</option>
                    <option value="Ankle Support">Ankle Support</option>
                    <option value="Dual Density Sole">Dual Density Sole</option>
                    <option value="Studded Sole">Studded Sole</option>
                    <option value="All terrain Shoes">All terrain Shoes</option>
                    <option value="Arch Support">Arch Support</option>
                    <option value="orthopedic footbed">Orthopedic Footbed</option>
                </b-form-select>
              </b-form-group>
              </b-col>


              <b-col md="4" class="mt-2" v-if = "selected_sub_catid === 170">
              <label>Fastening_type</label>
              <b-form-group>
                <b-form-select placeholder="Select" v-model="Fastening_type"
                required
                  class="input">
                    <option value="">--Select--</option>
                    <option value="slip-on">Slip-On</option>
                    <option value="lace-up">Lace-Up</option>
                    <option value="buckle">Buckle</option>
                    <option value="zip">Zip</option>
                    <option value="elastic">Elastic</option>
                    <option value="velcro">Velcro</option>
                    <option value="velcro+Elastic">Velcro + Elastic</option>
                    <option value="snap button">Snap Button</option>
                </b-form-select>
              </b-form-group>
              </b-col>

              <b-col md="4" v-if="selected_sub_catid !== 170">
                <label>Material</label>
                 <b-form-group>
                    <b-form-select v-model="material" id="material" name="material" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.material') }">
                      <!-- <option :value='null' >Select Option</option> -->
                      <option :value="fabrictype_list.title" v-for="fabrictype_list in fabrictype_arr">{{ fabrictype_list.title }}</option>
                    </b-form-select> 
                  </b-form-group>
              </b-col>
              <b-col md="4"  v-if="selected_sub_catid !== 170">
                <label>Top Fabric Type</label>
                 <b-form-group>
                    <b-form-select v-model="topfabrictype" id="topfabrictype" name="topfabrictype" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.topfabrictype') }">
                      <!-- <option :value='null' >Select Option</option> -->
                      <option :value="topfabrictype.title" v-for="topfabrictype in top_fabric_arr">{{ topfabrictype.title }}</option>
                    </b-form-select> 
                  </b-form-group>
              </b-col>

              <b-col md="4" v-if="selected_sub_catid !== 170">
                <label>Bottom Fabric Type</label>
                 <b-form-group>
                    <b-form-select v-model="bottomfabrictype" id="bottomfabrictype" name="bottomfabrictype" v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.bottomfabrictype') }">
                      <!-- <option :value='null' >Select Option</option> -->
                      <option :value="bottomfabrictype.title" v-for="bottomfabrictype in top_fabric_arr">{{ bottomfabrictype.title }}</option>
                    </b-form-select> 
                  </b-form-group>
              </b-col>






              <b-col md="4">
               <label>Segment</label>
               
                <b-form-group >
                
                  <b-form-select @change="showCollection(brandid , selected_segment_id)"
                    v-model="selected_segment_id"
                    id="selected_segment_id"
                    name="selected_segment_id"
                  >
                    <!-- <option :value="null">--Select--</option> -->
                    <option v-for="segmentlist in segmentarray_list" :value="segmentlist.segment_id" >{{
                      segmentlist.segment_title
                    }}</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="4">
               <label>Seasons Name</label> 
                <b-form-group >
                  <b-form-select 
                    v-model="selected_collection_id"
                    id="selected_collection_id"
                    name="selected_collection_id"
                  >
                    <!-- <option :value="null">--Select--</option> -->
                    <option v-for="collection in collectionData" :value="collection.collection_id" >{{
                      collection.collection_title
                    }}</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="4">
               <label>Category Name</label>
               
                <b-form-group >  
                  <b-form-select
                    v-model="selected_categoryId"
                    id="selected_categoryId"
                    name="selected_categoryId"
                  >
                    <!-- <option :value="null">--Select--</option> -->
                    <option v-for="collection in collectionData" :value="collection.category_id" >{{
                      collection.category_title
                    }}</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="4">
               <label>Sub-category Name</label> 
                <b-form-group >
                  <b-form-select @change="getPoTypeList(); getUtilityTypeList(); getSubCategory(sub_catid)"
                    v-model="sub_catid"
                    id="sub_catid"
                    name="sub_catid"
                  >
                    <!-- <option :value="null">--Select--</option> -->
                    <option v-for="subcatarry in sub_cat_id_arr" :value="subcatarry.sub_catid" >{{
                      subcatarry.sub_cattitle
                    }}</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
               <b-col md="4">
                <label>PO Type</label>
                <b-form-group >
                
                  <b-form-select
                    v-model="selected_po_id"
                    id="selected_po_id"
                    name="selected_po_id"
                  >
                    <!-- <option :value="null">--Select--</option> -->
                    <option v-for="polist in po_typearr" :value="polist.po_id">{{
                      polist.potype_title
                    }}</option>
                  </b-form-select>
                </b-form-group>
              </b-col>

               <b-col md="4">
                <label>Utility Type</label>
                <b-form-group >
                
                  <b-form-select
                    v-model="selected_utility_id"
                    id="selected_utility_id"
                    name="selected_utility_id"
                  >
                    <!-- <option :value="null">--Select--</option> -->
                    <option v-for="ulist in utility_typearr" :value="ulist.utility_id">{{
                      ulist.utilitytype_title
                    }}</option>
                  </b-form-select>
                </b-form-group>
              </b-col>

               <b-col md="4">
                  <label>EPP</label>
                   <b-form-group>
                      <b-form-select v-model="is_epp" id="is_epp" name="is_epp"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.is_epp') }">
                      
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </b-form-select> 
                    </b-form-group>

              </b-col>

             <b-col  md="4">
                <b-form-group label="Style Comment">
                <b-form-textarea
                    type="text"
                    name="Comment"
                    v-model="style_comment"
                    placeholder="Enter Style Comment"
                    required
                >
                <span class="icon has-text-warning">
                    <i class="fa fa-warning" v-show="errors.has('Comment')" ></i>
                    </span>
                    <code v-show="errors.has('form-5.Comment')" id="Comment" class="help text-danger">{{ errors.first('form-5.Comment') }}
                    </code>
                </b-form-textarea>
                </b-form-group>

              </b-col>
              

              

              <b-col md="4">
                <label>Select Panton Type</label>
                <b-form-group>
                <b-form-select
                  list="family-list-id"
                  v-model="selected_panton_type"
                  placeholder="Select Panton Type"
                  @change="
                    colortypecheck(selected_panton_type);
                    getselectedfamilycolor(selected_panton_type);
                  "
                >
                  <!-- <option value="">--Select--</option> -->
                  <option value="TPG">TPG</option>
                  <option value="TCX">TCX</option>
                  <option value="OTHERS">OTHERS</option></b-form-select
                >
                </b-form-group>
              </b-col>
              <b-col md="4">
                <div v-if="selected_panton_type != 'OTHERS'">
                 <label>Select Panton Color</label>
                  <b-form-group
                    id="pantom_color_block"
                  >
                    <v-select required
                      id="mySelect"
                      v-model="pantone_color"
                      :options="color_name"
                      name="selected_pantone_no"
                      list="list"
                      @change="
                        setSelectedcolor(pantone_color, 1);
                      "
                      placeholder="Select Panton Color"
                    >
                    </v-select>
                  </b-form-group>
                  <label>Selected Color</label>
                    <b-form-group id="selectedcolor">
                    
                    <div md="6" v-if="selected_final_color.color != selected_mutlicolor.color || selected_final_color.color != null || selected_final_color.color != '' "   v-for="(color,index) in selected_final_color" class="d-flex flex-flow justify-content-between border m-1 p-1" :style="`background-color:${color.split(' ').pop()};`" :id="'color'+index">
                    <span>{{color}}</span> <i class="fa fa-close" @click="()=>removecolor(index)"></i>
                    </div>
                    <div></div>

                    <div class="m-1 p-1 d-flex flex-flow justify-content-between border" v-for="(colors,index) in selected_mutlicolor" :style="`background-color:${colors.split(' ').pop()}`" :id="'colors'+index">
                        {{ colors }}  <i class="fa fa-close" @click="()=>removeselectedcolor(index)"></i>

                    </div>

                  </b-form-group>
                </div>
                  <b-form-group 
                    id="other_value_block"   
                     v-if="selected_panton_type == 'OTHERS'"      
                    >
                    <label>Color</label>
                      <b-form-input
                        type="text"
                        name="color"
                        v-model="otherColor"
                        placeholder="Enter Color Name"
                      >
                      </b-form-input>
                    </b-form-group>
                    
                    <!-- <b-form-group class=""
                      v-if="selected_panton_type == 'OTHERS' && colorcheck != 'OTHERS' "     
                    >
                    <label>Color</label>
                      <b-form-input
                        type="text"
                        name="color"
                        v-model="otherColor"
                        placeholder="Enter Color Name"
                      >
                      </b-form-input>
                  </b-form-group> -->

              </b-col> 

             
            <b-col  md="4" v-if="selected_sub_catid !== 170" > 
              <label>Fabric Type</label>
              <b-form-group >
                <b-form-select v-model="fabrictype" id="fabrictype" name="fabrictype"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.fabrictype') }">
                      <!-- <option :value="selected" >Select Option</option> -->
                      <option value="knit">Knit</option>
                      <option value="woven">Woven</option>
                    </b-form-select> 
              
                    <b-input-group >
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('fabrictype')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.fabrictype')" id="statustxt" class="help text-danger">{{ errors.first('form-5.fabrictype') }}
                      </code>
                    </b-input-group>
                </b-form-group>

              </b-col>
              <b-col md="4"  v-if="selected_sub_catid !== 170">
                <label>Pack Of</label>
                <b-form-group>
                  <b-form-select v-model="pack_of" id="pack_of" name="pack_of"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.pack_of') }">
                    <!-- <option :value="selected" >Select Option</option> -->
                    <option :value="1" >Single</option>
                    <option v-for="pack in Array.from({ length: 10 - 2 + 1 }, (_, i) => i + 2)" :value="pack">Pack of {{pack}}</option>
                  </b-form-select> 
                  <b-input-group>
                    <span class="icon has-text-warning">
                      <i class="fa fa-warning" v-show="errors.has('pack_of')" ></i>
                    </span>
                    <code v-show="errors.has('form-5.pack_of')" id="pack_of" class="help text-danger">{{ errors.first('form-5.pack_of') }}
                    </code>
                  </b-input-group>
                </b-form-group>
              </b-col>
              
            </b-row>
         

            <div slot="footer" class="text-right mt-3">
               <b-button size="sm" type="submit" variant="success" 
                >Update</b-button
              >
              <b-button size="sm" class="ml-2" variant="danger" @click="designDetailsModelcancel()"
                >Cancel</b-button
              >
            </div>
          </b-form>
        </template>
      </b-modal>
      <!-- Code For EDIT DESIGN DETAILS Ends -->

      <!-- Code For Activity Log -->
      <b-modal
        title="Activity Logs"
        v-model="activitylogModel"
        @ok="activitylogModel = false"
        size="lg"
      >
        <h5>Activity Logs</h5>

        <template slot="default" slot-scope="{ hide }">
          <b-form
            @submit.prevent="validateForm4('form-5')"
            data-vv-scope="form-5"
          >
            <div class="col-md-12">
              <b-table
                class="mt-4"
                show-empty
                stacked="md"
                :items="style_activity"
                :fields="fields1"
                :bordered="bordered"
              >
                <template slot="initiated_by" slot-scope="row">
                  <div v-if="row.item.initiated_by == null">
                    {{ row.item.vendor_name }}
                  </div>
                  <div v-if="row.item.initiated_by != null">
                    {{ row.item.initiated_by }}
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>

                <template
                  slot="view_details"
                  slot-scope="row"
                  v-if="row.item.style_action != 'STYLE_CREATED'"
                >
                  <button type="button" @click="showactivitydetails(row.item)">
                    <i
                      class="fa fa-info-circle"
                      aria-hidden="true"
                      style="color: #1082F3"
                    ></i>
                  </button>
                  &nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-default"
                    @click="vendorsquotesdetails()"
                    v-if="
                      row.item.operation_name == 'QuoteCreated' ||
                        row.item.operation_name == 'QuoteRecieved'
                    "
                  >
                    <i
                      class="fa fa-users"
                      aria-hidden="true"
                      style="color: #1E90FF; "
                    ></i
                    >Quoatation List
                  </button>
                </template>

                <!-- <template slot="view_details" slot-scope="row" v-if="row.item.style_action!='STYLE_CREATED'">
                      <button type='button'   @click="showactivitydetails(row.item)" >
                              <i class="fa fa-info-circle" aria-hidden="true" style="color: #1082F3"></i>
                          </button>

                    </template> -->

                <b-dropdown-item></b-dropdown-item>
              </b-table>
            </div>

            <div slot="footer" class="text-right">
              <b-button size="sm" variant="danger" @click="activitylogcancel()"
                >cancel</b-button
              >
            </div>
          </b-form>
        </template>
      </b-modal>
      <!-- Code For Activity Log Ends -->
      <!-- Activity Details Model -->
      <!-- Code For Activity Log -->
      <b-modal
        :title="selected_style_action"
        v-model="activitydetailsModel"
        @ok="activitydetailsModel = false"
        size="md"
      >
        <!-- <template slot="modal-header">
          <h5>{{selected_style_action}}</h5>
          
          </template> -->
        <!-- <template slot="default" slot-scope="{ hide }"> -->
        <template slot="default" slot-scope="{ hide }">
          <b-form
            @submit.prevent="validateForm4('form-5')"
            data-vv-scope="form-5"
          >
            <div
              class="col-md-12"
              v-if="
                selected_style_action === 'Sample_Image_Change' ||
                  selected_style_action === 'Image_Change'
              "
            >
              <b-row>
                <div class="col-md-4"><b>Previous Value</b></div>
                <div class="col-md-12">
                  <img
                    v-bind:src="selected_old_value"
                    height="100"
                    width="150"
                    style="padding:5px;"
                  />
                </div>
                <br /><br />
                <div class="col-md-4"><b>New Change</b></div>
                <div class="col-md-12">
                  <img
                    v-bind:src="selected_new_value"
                    height="100"
                    width="150"
                    style="padding:5px;"
                  />
                </div>
                <div class="col-md-4"></div>
              </b-row>
            </div>

            <div
              class="col-md-12"
              v-if="
                selected_style_action !== 'Sample_Image_Change' &&
                  selected_style_action !== 'Image_Change'
              "
            >
              <b-row>
                <div class="col-md-4"><b>Previous Value</b></div>
                <div class="col-md-12">{{ selected_old_value }}</div>
                <br /><br />
                <div class="col-md-4"><b>New Change</b></div>
                <div class="col-md-12">{{ selected_new_value }}</div>
                <div class="col-md-4"></div>
              </b-row>
            </div>

            <div slot="footer" class="text-right">
              <b-button
                size="sm"
                variant="danger"
                @click="activitydetailscancel()"
                >cancel</b-button
              >
            </div>
          </b-form>
        </template>
        <template slot="modal-footer" slot-scope="{ hide }">
          <b-button size="sm" style="display:none">
            Cancel
          </b-button>
        </template>
      </b-modal>
      <!-- Code For Activity Log Ends -->
      <!-- Activity Details Model Ends -->

      <!-- Code For Vendors Quotes  -->
      <b-modal
        title="Vendors Quotes Logs"
        v-model="quotationlistModel"
        @ok="quotationlistModel = false"
        size="lg"
      >
        <h5>Activity Logs</h5>

        <template slot="default" slot-scope="{ hide }">
          <b-form
            @submit.prevent="validateForm4('form-5')"
            data-vv-scope="form-5"
          >
            <div class="col-md-12">
              <div class="col-md-12">
                <p style="float: right;">
                  <b
                    >Total Records :<span style="color:red;">{{
                      quotation_count
                    }}</span></b
                  >
                </p>
              </div>

              <!-- <div class="col-md-12"> -->
              <!-- <div class="col-md-12"> -->
              <!-- <b-card  style="padding-top:10px;"> -->
              <!-- <div class="col-md-12"> -->
              <b-table
                class="mt-4"
                show-empty
                stacked="md"
                :busy="isBusy"
                :current-page="currentPage"
                :perPage="perPage"
                :items="vendors_items"
                :fields="vendors_fields"
                :bordered="bordered"
              >
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </b-table>

              <b-col md="6" class="my-1" v-if="quotation_count > 10">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="quotation_count"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </div>

            <div slot="footer" class="text-right">
              <b-button
                size="sm"
                variant="danger"
                @click="quotationlistModelcancel()"
                >cancel</b-button
              >
            </div>
          </b-form>
        </template>
      </b-modal>
      <!-- Code For Vendors Quotes Ends -->

      <!-- Add Comment Model -->
      <!-- Code For Edit Design -->
      <b-modal
        title="Add Comment"
        v-model="addcommentModel"
        @ok="addcommentModel = false"
      >
        <template slot="modal-header">
          <h5>Comment Section</h5>
          <button
            type="button"
            class="close"
            aria-label="Close"
            slot-scope="{ hide }"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </template>
        <template slot="default" slot-scope="{ hide }">
          <b-form
            data-vv-scope="form-5"
            @submit.prevent="updatestylestatus(comment, status)"
          >
            <b-form-group label="Comment" :label-cols="3">
              <b-form-textarea
                rows="3"
                max-rows="6"
                v-model="comment"
                type="text"
                name="comment"
                placeholder="Enter Comment Here..."
              >
              </b-form-textarea
              ><br />
              <b-input-group class="mb-3">
                <label class="radio-inline"
                  ><input
                    type="radio"
                    name="optradio"
                    value="approved"
                    v-model="status"
                    @click="selectGrade()"
                    checked
                  />&nbsp;Approved</label
                >&nbsp;&nbsp;
                <label class="radio-inline"
                  ><input
                    type="radio"
                    name="optradio"
                    value="rejected"
                    v-model="status"
                  />&nbsp;Reject</label
                >&nbsp;&nbsp;
                <label class="radio-inline"
                  ><input
                    type="radio"
                    name="optradio"
                    value="Feedback"
                    v-model="status"
                  />&nbsp;Feedback</label
                >&nbsp;&nbsp;
              </b-input-group>
            </b-form-group>

            <div slot="footer" class="text-right">
              <b-button type="submit" size="sm" class="mr-4" variant="primary">
                Update Status</b-button
              >
              <b-button size="sm" variant="danger" @click="commentcancel()"
                >cancel</b-button
              >
            </div>
          </b-form>
        </template>
        <template slot="modal-footer" slot-scope="{ hide }">
          <b-button size="sm" style="display:none">
            Cancel
          </b-button>
        </template>
      </b-modal>
      <!-- Code For Edit Design Ends -->
      <!-- Add Comment Model Ends -->

      <!-- Add File Model -->
      <b-modal
        title="Add File"
        v-model="uploadfilemodel"
        @ok="uploadfilemodel = false"
      >
        <b-form name="fileform" @submit.prevent="addDesignFiles('fileform')">
          <b-col>
            <b-card show-footer>
              <b-col sm="12">
                <b-form-group>
                  <label for="name">Enter File Title</label>
                  <b-form-input
                    type="text"
                    id="name"
                    v-model="file_title"
                  ></b-form-input>
                </b-form-group>

                <b-form-group>
                  <label for="name">Select Category</label>
                  <b-form-select
                    id="month1"
                    :plain="true"
                    v-model="file_category"
                    :options="file_Category_options"
                  >
                  </b-form-select>
                </b-form-group>

                <b-form-group>
                  <label for="name">File url</label>
                  <b-form-input
                    type="text"
                    id="name"
                    v-model="file_url_path"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <div slot="footer">
                <b-button
                  type="submit"
                  style="float:right"
                  variant="primary"
                  class="px-4"
                  block
                  >Add File</b-button
                >
              </div>
            </b-card>
          </b-col>
        </b-form>
      </b-modal>
      <!--  End Add File Model -->
                 <!-- Grading Modal -->
                 <b-modal id="showGradeModal" size="md" title="Select grade for the style" v-model="showGradeModal" @ok="showGradeModal = false" v-if="user_type !='Admin' && user_type !='Buying_Head'">
            <b-form
            name="addSegmentForm"
             @submit.prevent="validategrade()">
                
            <b-col sm="12">
                <label for="grade">Select Grade</label>
                <b-form-group>
                <b-form-select required
                    v-model="selected_Grade"
                    id="selected_Grade"
                    name="selected_Grade">
                    <option :value="null">--Select--</option>
                    <option value="A+" >A+</option>
                    <option value="A" >A</option>
                    <option value="B+" >B+</option>
                    <option value="B" >B</option>
                    <option value="C+" >C+</option>
                    <option value="C" >C</option>
                    <option value="D" >D</option>

                </b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="5" style="float:right">
                <b-button type="submit" variant="primary">Submit</b-button> &nbsp;
                <b-button type="button" variant="danger" @click="cancelshowGradeModal()">Cancel</b-button>
            </b-col> 

            </b-form>   
          </b-modal>

    </b-row>
  </div>
</template>

<style type="text/css">
#pdfoverride .vue-pdf-embed canvas {
  width: 300px !important;
  height: 200px !important;
}
#map-1 canvas {
  width: 100% !important;
  height: 100% !important;
}

.img-magnifier-container {
  position: relative;
}

.img-magnifier-glass {
  position: absolute;
  border: 3px solid #000;
  border-radius: 50%;
  cursor: none;
  /*Set the size of the magnifier glass:*/
  width: 200px;
  height: 200px;
}
</style>

<script>
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import CONSTANTS from "@/utils/constants";
import auth from "@/utils/auth";
import Vue from "vue";
import Router from "vue-router";
//import {ImageMagnifier} from 'vue-image-magnifier'
import ImageMagnifier from "vue-image-magnifier";
Vue.use(ImageMagnifier);
import sidebarAllDesignsComponent from "./_sidebarAllDesignsComponent.vue";
import navbarMenu from "./_navbarMenu.vue";
const SIZE = 10 * 1024 * 1024;

const axios = require("axios");
export default {
  name: "Tabs",
  components: {
    sidebarAllDesignsComponent,
    navbarMenu,
    VuePdfEmbed,
  },

  data() {
    return {
      addfile: false,
      showSideMenu: true,
      tabs: ["Calculator", "Shopping cart", "Charts"],
      quotationAddModal: false,
      msgRows: 0,
      isMagnifierVisible: false,
      style_details: [],
      quateitemlist: [],
      design_title: "",
      story_name: "",
      design_id: "",
      design_date: "",
      collection_title: "",
      imgpath: "",
      totalRows: 0,
      quote_date: "",
      quote_quantity: "",
      quote_currency: "",
      quote_prce_per: "",
      price_per_garment: "",
      quote_status: "",
      quote_unit: "",
      quantity: [],
      visible: true,
      list: [],
      customer: {},
      messagedata: [],
      selectedId: 0,
      txtInput: "",
      title: "",
      design_no: "",
      uploadfilemodel: false,
      activitylogsmodel: false,
      quote_tab: false,
      message_tab: false,
      files_list: [],
      nav_design_list: [],
      catselected: "",
      subcatselected: "",
      cat_title: "",
      sub_cat_title: "",

      file_title: "",
      file_category: "",
      file_url_path: "",
      file_Category_options: [
        { value: "Technical Pack", text: "Technical Pack" },
        { value: "Fabric", text: "Fabric" },
        { value: "Constructions", text: "Constructions" },
      ],

      no_of_unit: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
      ],
      color_family: [],

      //Code for sampling
      requestSampleModal: false,
      // requestedlisting:[],

      selectedDate: new Date(),
      // items:[],
      result: [],
      sample_data: [],
      //Sampling code ends

      colortype: {},
      customer: {},
      colorcode: {},
      color_name: [],
      color_family: [],
      pantoncolor: [],
      showhexcolor: "",
      pantonno_result: [],
      showcolorname: "",
      SelectPantonType: "",

      quoteunit: [{ value: "INR", text: "INR" }],

      activeTab: 1,

      //New Added Code
      editdesign: false,
      design_categoty_id: 0,
      design_subcategoty_id: 0,
      updated_by: "",
      segment_id: 0,
      utility_type_arr: [],
      no_of_units_in_pack: 0,
      no_of_colors: 0,
      no_of_size_sets: 0,
      style_image: "",
      file: "",
      po_typearr: [],
      sub_cat: [],
      selectedPO_type: null,
      selected_sub_category: null,
      selected: "",
      route_id: "",
      addcommentModel: false,
      activitylogModel: false,
      designDetailsModel: false,
      topfabrictype:'',
      bottomfabrictype:'',
      comment: "",
      status: "",
      user_type: "",
      temp_color: "",
      temp_style_name: "",
      temp_style_image: "",
      temp_style_description: "",
      flag: 0,
      img_data: "",
      temp_sizeset: 0,
      temp_story_name: "",
      tp_status: false,
      measurementchart_status: false,
      bom_status: false,
      fileupload_status: false,
      openimagemodel: false,
      openartworkimagemodel: false,
      opentablemodel: false,
      //name:"design_details",
      name: "auth",
      component_name: "design_details",
      sytleImageurl: "",
      sampleFile: "",
      sampleImageurl: "",
      chnaged_image: false,
      selected_draft_value: 0,
      remoteUrl: "",
      temp_file: "",
      progress: 0,
      progress1: 0,
      no_of_sizeset: [
        { value: "0", text: "0" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
        { value: "17", text: "17" },
        { value: "18", text: "18" },
        { value: "19", text: "19" },
        { value: "20", text: "20" },
      ],
      // ,tdClass: 'nameOfTheClass' tdClass: 'viewClass'
      fields1: [
        { key: "operation_name", label: "Operation Name" },
        // { key: 'status', label: 'Status'},
        { key: "time", label: "Time" },
        { key: "time_stamp", label: "Time Stamp" },
        { key: "initiated_by", label: "Event Initiated By" },
        { key: "view_details", label: "View Details" },
      ],
      vendors_fields: [
        //{ key: 'selected', label: 'Selected'},tdClass: 'nameOfTheClass'sortable: true, sortDirection: 'desc'
        { key: "vendor_name", label: "Vendor Name" },
        { key: "quantity", label: "Quantity" },
        { key: "target_price", label: "Target Price" },
        { key: "updated_date", label: "Request Date" },
        { key: "effective_date", label: "Submitted Date" },
        { key: "status", label: "Status" },
      ],
      stylePdfUrl: "",
      style_pdf_image: "",
      style_activity: [],
      bordered: true,
      activitydetailsModel: false,
      selected_old_value: "",
      selected_new_value: "",
      selected_style_action: "",
      selected_status_code_number: 0,
      vendors_items: [],
      quotation_count: 0,
      quotationlistModel: false,
      isBusy: false,
      perPage: 10,
      currentPage: 1,
      sizeset: [],
      invoice_products: [
        {
          unit: [],
          selectedfromage: [],
          selectedtoage: [],
          quantity: [],
          factorysize: [],
        },
      ],
      range_selectedfromage: [],
      temp_range_selectedfromage: [],
      range_selectedtoage: [],
      range_selected_month: [],
      selected_month: [],
      selected_age: 0,
      selectedfromage: [],
      selectedtoage: [],
      month_arr: [
        { value: "0", text: "0" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
        { value: "17", text: "17" },
        { value: "18", text: "18" },
        { value: "19", text: "19" },
        { value: "20", text: "20" },
        { value: "21", text: "21" },
        { value: "22", text: "22" },
        { value: "23", text: "23" },
        { value: "24", text: "24" },
      ],
      year_arr: [
        { value: "0", text: "0" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
      ],
      to_month_arr: [
        { value: "0", text: "0" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
        { value: "17", text: "17" },
        { value: "18", text: "18" },
        { value: "19", text: "19" },
        { value: "20", text: "20" },
        { value: "21", text: "21" },
        { value: "22", text: "22" },
        { value: "23", text: "23" },
        { value: "24", text: "24" },
      ],
      to_year_arr: [
        { value: "0", text: "0" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
      ],
      agefrmto_default: [{ value: "", text: "-- Select --" }],
      factorysize: [],
      unit_arr: [
        { value: "0", text: "Month" },
        { value: "1", text: "Year" },
      ],
      index: 1,
      age_from: [],
      //age_to: [],
      age_to: [],
      total_quantity: 0,
      sizesetselect: false,
      tbl_selected_month: [],
      tbl_selectedfromage: [],
      tbl_selectedtoage: [],
      tbl_invoice_products: [
        {
          tbl_unit: [],
          tbl_selectedfromage: [],
          tbl_selectedtoage: [],
          tbl_factorysize: [],
          tbl_quantity: [],
        },
      ],

      tbl_unit: [],
      tbl_selectedfromage: [],
      tbl_selectedtoage: [],
      tbl_factorysize: [],
      tbl_quantity: [],
      selected_color_family: "",
      temp_selected_color_family: "",
      selected_pantone_no: "",
      selected_panton_type: "",
      temp_selected_panton_type: "",
      temp_selected_pantone_no: "",
      otherColor: "",
      selected_color: "",
      selected_final_color: [],
      selected_final_color1:'',
      selected: "",
      block_status: true,
      access_token: "",
      submit_enable_btn: 0,
      temp_index: [],
      temp_unit: [],
      temp_from_age: [],
      temp_to_age: [],
      selected_sizeset: null,
      selected_po_id: "",
      selected_style_type: '',
      fabrictype:"",
      fabrictype_arr:[],
      topfabrictype_arr :[],
      bottomfabrictype_arr:[],
      bottom_fabric:'',
      bottom_fabric_arr:[],
      top_fabric:'',
      top_fabric_arr:[],
      brandid:'',
      sub_catid: "",
      user_name: "",
      //file_tab_status: false,
      //New Added Code Ends
      // For mutlitple color displya
      selected_mutlicolor:[],
      arraymerge:[],
      pantone_color:'',
      sytleImageurl: "",
      selectFiletype: "",
       container: {
        file: null,
        hash: "",
        worker: null,
        filename: null,
      },
      stytleImageurl: "",
      stylePdfUrl: "",

      data: [],

      // Edit draft modal
      optionsstyletype: [
          // { value: "null" , text: "Select Style Type"},
          { value: "new", text: 'New' },  
          { value: "carry forward", text: 'Carry Forward' },
          { value: "repeat", text: 'Repeat' },
          { value: 'BOBS', text: 'BOBS'},
          { value: 'vendor sample', text: 'Vendor Sample'},

        ],
        isSidebarRefresh: false,

      // other api integration for edit style details
      // segment /collection./seasons/category/sub cat
      user_id:"",
      brand_assign:"",
      selected_brand_manager:"",
      segmentList_arr:[],
      segmentarray_list:[],
      selected_segment_id:"",
      selected_categoryId:'',
      collectionData: [],
      collection_brand_id: "",
      collection_segment_id: "",
      selected_collection_id:'',
      subcatlist_arr : [],
      sub_cat_id_arr :[],
      selected_utility_id:'',
      utility_typearr: [],
      colorcheck:'',
      style_id:'',
      selected_edited_color:'',
      pack_of:'',
      is_epp:'',
      material: '',   
      showDeleteStyleModel: false,
      style_comment:'',
      total_mrp:'',
    // For grading system
      showGradeModal: false,
      selected_Grade:null,
      uk:[],
      us:[],
      foot_length_cm:[],
      brand_size_euro:[],
      selected_sub_catid:'',
      cat_id:'',
      isDraggingSample: false,
      file1: null,
      file: null,
      isDraggingDesign: false,
    };
  },
  created: function() {
    var userData = localStorage.getItem("userData");
    var userInfo = JSON.parse(userData);

    this.route_id = this.$route.params.id;
    this.sub_cat_id_arr = userInfo[0].subcat_assign;
    // var userData = localStorage.getItem('userData');
    // var userInfo = JSON.parse(userData);
    this.user_type = userInfo[0].user_type;
    this.user_name = userInfo[0].full_name;
    console.log("usertype", this.user_type);
    this.getdesigndetail();
    this.getcolorfamilylist();
  },

  mounted() {},
  methods: {
    setsizeset: function(unit, from_age, to_age) {
      this.invoice_products[0].unit = [];
      this.invoice_products[0].selectedfromage = [];
      this.invoice_products[0].selectedtoage = [];
      this.invoice_products = [
        {
          unit: [],
          selectedfromage: [],
          selectedtoage: [],
          quantity: [],
          factorysize: [],
        },
      ];

      this.range_selected_month = "";
      this.range_selectedtoage = 0;
      this.range_selectedfromage = 0;

      this.range_selectedtoage = to_age;
      this.range_selectedfromage = from_age;
      this.range_selected_month = unit;

      if (parseInt(from_age) < parseInt(to_age)) {
        this.selected_sizeset =
          this.range_selectedtoage - this.range_selectedfromage;

        this.temp_range_selectedfromage = this.range_selectedfromage;
        for (var i = 0; i <= this.selected_sizeset; i++) {
          this.invoice_products[0].unit.push(unit);
          this.invoice_products[0].selectedfromage.push(
            this.temp_range_selectedfromage
          );
          this.invoice_products[0].selectedtoage.push(
            parseInt(this.temp_range_selectedfromage) + 1
          );
          this.temp_range_selectedfromage =
            parseInt(this.temp_range_selectedfromage) + 1;
        }

        for (var i = 0; i <= this.selected_sizeset; i++) {
          this.selected_month[i] = this.invoice_products[0].unit[i];
          this.selectedfromage[i] = this.invoice_products[0].selectedfromage[i] ? this.invoice_products[0].selectedfromage[i] :'';
          this.selectedtoage[i] = this.invoice_products[0].selectedtoage[i] ? this.invoice_products[0].selectedtoage[i] :'';
          this.temp_index.push(i);
        }

        this.sizeset = [];

        for (var i = 1; i <= this.selected_sizeset; i++) {
          this.sizeset.push(i);
        }

        document.getElementById("sizesetData").style.display = "block";
        //     this.temp_unit.push(this.invoice_products[0].unit);
        //     this.temp_from_age.push(this.invoice_products[0].selectedfromage);
        //     this.temp_to_age.push(this.invoice_products[0].selectedtoage);
        // this.temp_index.push(this.temp_index);
        // this.submit_enable_btn=1;
        // this.AddDesignfunction();
        // updatestyle(event,value,unit,from_age,to_age,index);
      } else if (parseInt(from_age) >= parseInt(to_age)) {
        this.$fire({
          text: "Age To Value Should Be Greater Than Age From Value.",
          type: "warning",
          timer: 30000,
        });
      }
    },

    magnifyImage: function(imgID, zoom) {
      var img, glass, w, h, bw;
      img = document.getElementById(imgID);
      /*create magnifier glass:*/
      glass = document.createElement("DIV");
      glass.setAttribute("class", "img-magnifier-glass");
      glass.setAttribute("id", "magnifyingGlass");
      /*insert magnifier glass:*/
      img.parentElement.insertBefore(glass, img);
      /*set background properties for the magnifier glass:*/
      glass.style.backgroundImage = "url('" + img.src + "')";
      glass.style.backgroundRepeat = "no-repeat";
      glass.style.backgroundSize =
        img.width * zoom + "px " + img.height * zoom + "px";
      bw = 3;
      w = glass.offsetWidth / 2;
      h = glass.offsetHeight / 2;
      /*execute a function when someone moves the magnifier glass over the image:*/
      glass.addEventListener("mousemove", moveMagnifier);
      img.addEventListener("mousemove", moveMagnifier);
      /*and also for touch screens:*/
      glass.addEventListener("touchmove", moveMagnifier);
      img.addEventListener("touchmove", moveMagnifier);
      function moveMagnifier(e) {
        var pos, x, y;
        /*prevent any other actions that may occur when moving over the image*/
        e.preventDefault();
        /*get the cursor's x and y positions:*/
        pos = getCursorPos(e);
        x = pos.x;
        y = pos.y;
        /*prevent the magnifier glass from being positioned outside the image:*/
        if (x > img.width - w / zoom) {
          x = img.width - w / zoom;
        }
        if (x < w / zoom) {
          x = w / zoom;
        }
        if (y > img.height - h / zoom) {
          y = img.height - h / zoom;
        }
        if (y < h / zoom) {
          y = h / zoom;
        }
        /*set the position of the magnifier glass:*/
        glass.style.left = x - w + "px";
        glass.style.top = y - h + "px";
        /*display what the magnifier glass "sees":*/
        glass.style.backgroundPosition =
          "-" + (x * zoom - w + bw) + "px -" + (y * zoom - h + bw) + "px";
      }
      function getCursorPos(e) {
        var a,
          x = 0,
          y = 0;
        e = e || window.event;
        /*get the x and y positions of the image:*/
        a = img.getBoundingClientRect();
        /*calculate the cursor's x and y coordinates, relative to the image:*/
        x = e.pageX - a.left;
        y = e.pageY - a.top;
        /*consider any page scrolling:*/
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return { x: x, y: y };
      }
    },

    removeMagnifier: function() {
      let mg = document.getElementById("magnifyingGlass");
      if (mg) mg.remove();
    },

    showMagnifier: function() {
      let mg = document.getElementById("magnifyingGlass");
      if (mg == null) {
        this.magnifyImage("map", 4);
      } else {
        this.removeMagnifier();
      }
    },

    opensizesetdata: function(value) {
      // document.getElementById("size_range").style.display="block";
      this.sizeset = [];
      for (var i = 1; i <= value; i++) {
        this.sizeset.push(i);
      }

      document.getElementById("sizesetData").style.display = "block";
      // this.AddDesignfunction();
    },
    // Change Drop Down Value for Month & Year By Prasad
    range_changeMonthYearVal: function(value_for) {
      if (value_for == 0) {
        //month
        this.age_from = this.year_arr;
        this.selectedfromage = this.year_arr ? this.year_arr : '';
      } else {
        this.age_from = this.month_arr;
        this.selectedfromage = this.year_arr ? this.year_arr : '';
      }
    },

    finalcoloroutput: function(value) {
      // alert("Innnnnn")
      if (value == 1) {
        document.getElementById("final_color_output").style.display = "block";
      } else {
        document.getElementById("final_color_output").style.display = "none";
      }
    },
    colortypecheck: function(value) {
      // alert(value)
      // this.selected_pantone_no='';
      // this.setSelectedcolor(value);
      this.colorcheck = value;
      if (value != "OTHERS" && value != "") {
        document.getElementById("other_value_block").style.display = "none";
        // document.getElementById("pantom_color_block").style.display = "block";
        // document.getElementById("default_value_block").style.display = "none";
        // document.getElementById("selectedcolor").style.display = "block";
        // document.getElementById('pantom_color_block').style.display="block";
      } else {
        // this.selected_pantone_no='';
        // this.setSelectedcolor(value);

        if (value == "OTHERS") {
          // alert(this.otherColor)
          document.getElementById("other_value_block").style.display = "block";
          // document.getElementById("default_value_block").style.display = "none";
          document.getElementById("pantom_color_block").style.display = "none";
          document.getElementById("selectedcolor").style.display = "none";
        }
      }
    },

    opensizesetdata: function(value) {
      // alert(value)
      this.sizeset = [];
      for (var i = 1; i <= value; i++) {
        // alert("In")
        this.sizeset.push(i);
      }
    },

    // Change Drop Down Value for Month & Year By Prasad
    changeMonthYearVal: function(value_for, index) {
      if (value_for == 0) {
        //month
        //this.age_from[index] ="";
        this.age_from[index] = this.year_arr;
        this.selectedfromage[index] = this.year_arr ? this.year_arr : '';
      } else {
        this.age_from[index] = this.month_arr;
        this.selectedfromage[index] = this.year_arr ? this.year_arr : '';
      }
    },

    showactivitydetails(value) {
      this.selected_old_value = value.old_value;
      this.selected_new_value = value.new_value;
      this.selected_style_action = value.style_action;
      console.log("IIIIIIIIIIIIIIIII", value);
      this.activitydetailsModel = !this.activitydetailsModel;
    },

    quotationlistModelcancel: function() {
      this.quotationlistModel = false;
    },

    getStyleActivityLog() {
      const Obj = {
        style_id: this.$route.params.id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getStyleActivityLog`, Obj)
        .then((response) => {
          console.log("**********************", response);
          if (response.data.returnmsg == "Successful") {
            this.style_activity = response.data.returnvalue;
            this.activitylogModel = true;
          } else {
            this.style_activity = response.data.returnvalue;
            this.activitylogModel = true;
          }
        })
        .catch((err) => {
          return new Error(err.message);
        });
    },
    //Panton Color
    getcolorfamilylist: function(value) {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      const Obj = { color_type: "TCX" };
      axios
        .post(`${CONSTANTS.API_URL}/getcolorfamilylist`, Obj)
        .then((result) => {
          if (result.data.returnmsg === "Successful") {
            this.color_family = result.data.returnvalue;
          } else {
            this.color_family = [];
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },
    getselectedfamilycolor: function(color) {
      const Obj = {
        color_family: color,
      };
      this.temp_selected_panton_type = "";
      this.temp_selected_panton_type = color;
      console.log("temp_selected_panton_type", this.temp_selected_panton_type);
      axios
        .post(`${CONSTANTS.API_URL}/getlistagainstcolorfamily`, Obj)
        .then((result) => {
          this.result1 = result.data;
          if (this.result1.returnmsg === "Successful") {
            this.color_name = this.result1.returnvalue;
            var data = [];

            this.color_name.forEach(function(srData) {
              data.push({
                key: srData.pantone_no,
                label: srData.color_name + " - " + srData.pantone_no,
              });
            });
            console.log("OOOOOOOOOOOOOOOOOOOOOO", data);
            this.color_name = data;
          } else {
            this.color_name = [];
          }
        });
    },
    setSelectedcolor: function(value, checked_val) {
      // alert("innn");
      console.log("Vallllll", value);
      console.log("checked_val", checked_val);
      // var x=document.getElementById('opt').style.backgroundColor=opt.value;
      // .style.backgroundColor=colorData;
      // document.body.style.backgroundColor =  colorData;

      // var colorData='12-6204 TCX'

      if (checked_val == 0) {
        var Obj = {
          pantone_no: value,
        };
      } else {
        var Obj = {
          pantone_no: value.key,
        };
      }
      console.log("OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO", Obj);
      axios
        .post(`${CONSTANTS.API_URL}/getlistagainstpantonno`, Obj)
        .then((result) => {
          this.pantonno_result = result.data;
          if (this.pantonno_result.returnmsg === "Successful") {
            if (this.selected_panton_type != "OTHERS") {
              this.pantoncolor = this.pantonno_result.returnvalue;
              this.showhexcolor = this.pantoncolor[0].hex_code;
              // var temp_hex = this.pantoncolor[0].hex_code;
              this.showcolorname = this.pantoncolor[0].color_name;
              this.selected_final_color1 =
              this.showcolorname + " " + this.showhexcolor;

              this.selected_final_color.push(this.selected_final_color1)
              console.log("~~~~~~@@@@@@@@@@@@@@@@@@@@@@@@@~~~~~~~~~~~~~~~")
              console.log("#############", this.selected_final_color)
              console.log(this.selected_mutlicolor)

              // Create a copy of the first array
              const newArray1 = this.selected_final_color.slice();

              // Iterate through the copy of the first array
              for (const element of newArray1) {
                if (this.selected_mutlicolor.includes(element)) {
                  // If the element is in the second array, remove it from the first array
                  const index = this.selected_final_color.indexOf(element);
                  this.selected_final_color.splice(index, 1);
                }
              }

              console.log("First Array after removing duplicates: " + this.selected_final_color);
              console.log("Second Array with duplicates: " + this.selected_mutlicolor);

            }
          } else {
            this.pantoncolor = [];
             this.selected_final_color = [];
          }
        });
    },

    vendorsquotesdetails() {
      document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      // if (userData)
      // {
      var userInfo = JSON.parse(userData);
      this.vendor_id = userInfo[0].vendor_id;

      const Obj = {
        style_id: this.$route.params.id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getqutationdetails`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          // JSON responses are automatically parsed.
          this.result = response.data;
          this.quotationlistModel = true;
          if (this.result.returnmsg === "Successful") {
            this.vendors_items = this.result.returnvalue;
            this.isBusy = false;
            // this.totalRows = this.result.returnvalue.length;
            this.quotation_count = this.result.returnvalue.length;
            
            // for(var i=0;i<=this.quotation_count;i++)
            // {
            //    if(this.items[i].status=='Approved'){
            //      this.selected_status = 'Approved'
            //    }
            // }
          } else {
            this.vendors_items = [];
            this.isBusy = false;
            this.quotation_count = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    zoomin: function() {
      this.removeMagnifier();
      var myImg = document.getElementById("map");
      var currWidth = myImg.clientWidth;
      if (currWidth >= 680) return false;
      else {
        myImg.style.width = currWidth + 100 + "px";
      }
    },
    zoomout: function() {
      this.removeMagnifier();
      var myImg = document.getElementById("map");
      var currWidth = myImg.clientWidth;
      if (currWidth <= 270) return false;
      else {
        myImg.style.width = currWidth - 100 + "px";
      }
    },
    openimage: function() {
      this.openimagemodel = !this.openimagemodel;
    },
    openArtWorkimage: function() {
      this.openartworkimagemodel = !this.openartworkimagemodel;
    },
    openimagecancel: function() {
      this.openimagemodel = !this.openimagemodel;
    },
    openartworkimagecancel: function() {
      this.openartworkimagemodel = !this.openartworkimagemodel;
    },
    openNav: function() {
      var opennav = (document.getElementById("myNav").style.width = "25%");
    },
    closeNav: function() {
      var closenav = (document.getElementById("myNav").style.width = "0%");
    },

    

    /****** Function to add design image ********/
    AddDesignimage(event) {
      this.sytleImageurl = event.target.files[0];
      this.chnaged_image = true;
    },
    /****** Function to add design image ends ********/
    editStyledesign: function(style) {
      console.log('style@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@',style);
      this.pantone_color = ""
      console.log("style", style);
      this.sub_catid = style.sub_catid;
      this.selected_po_id = style.po_id;
      this.selected_style_type = style.style_type;
      this.fabrictype = style.fabrictype;
      this.material = style.material;
      this.otherColor = style.color;
      this.brandid = style.brand_id;
      this.sampleImageurl = style.sample_image;
      this.topfabrictype = style.materialinfoupperfabric;
      this.bottomfabrictype = style.solematerial
      this.pack_of = style.pack_of;
      this.is_epp = style.is_epp;
      this.style_comment = style.style_comment
      console.log(style.pack_of,"pack_of")
      this.editdesign = true;
      this.getPoTypeList();     
      this.fabrictypefunation();
    },

    //Update Collection Code

    updatestyle(event, value) {
      
      if(this.selected_mutlicolor.length != 0){
        console.log(".........................................")
      this.arraymerge = this.selected_final_color.concat(this.selected_mutlicolor)
      console.log(this.arraymerge);

      }
      else{
        this.arraymerge = this.selected_final_color
        console.log("..........removed previous data...............")
         console.log(this.arraymerge);
      }

      document.getElementById("progress_bar1").style.display = "none";
      this.progress1 = 0;

      this.invoice_products = [
        {
          unit: [],
          selectedfromage: [],
          selectedtoage: [],
          quantity: [],
          factorysize: [],
        },
      ];

      this.selected_draft_value = value;
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);

      var check_val = 0;

      var main_arr = [];
      main_arr.push(this.invoice_products[0]);

      // if (
      //   // this.temp_color != this.style_details.color ||
      //   this.temp_style_name != this.style_details.style_name 
      //   // this.temp_story_name != this.style_details.story_name
      // ) {
      //   this.flag = 1;
      // } else if (
      //   this.temp_color == this.style_details.color ||
      //   this.temp_style_description != this.style_details.style_description ||
      //   this.temp_style_name == this.style_details.style_name ||
      //   this.temp_style_image != this.style_details.style_image ||
      //   temp_story_name == this.style_details.story_name
      // ) {
      //   this.flag = 0;
      // }

      let data = new FormData();
      let config = {
        header: {
          "Content-Type": "multipart/form-data",
        },
      };

      //code for progressbar
      this.progress1 = 0;
      document.getElementById("overlay").style.display = "block";
      if (this.temp_file != undefined) {
        // alert("Iff");
      
          data.append("style_image", this.sytleImageurl);

        data.append("style_pdf", this.stylePdfUrl);
        data.append("style_pdf_image", this.style_pdf_image);
        data.append("sample_image", this.sampleImageurl);
        console.log("sample_image", this.sampleImageurl);
        data.append("style_id", this.$route.params.id);
        data.append("style_name", this.style_details.style_name);
        data.append("updated_by", userInfo[0].email_id);
        if (this.selected_panton_type == 'OTHERS') {
          data.append("color", this.otherColor);
          console.log(" If color", this.otherColor);
          this.temp_selected_pantone_no = "";
          this.arraymerge = "";
        } else {
          data.append("color", this.arraymerge);
          console.log(" else color", this.arraymerge);
        }
        data.append("no_of_sizeset", 0);
        data.append("story_name", this.style_details.story_name);
        data.append("style_type", this.selected_style_type);
        data.append("fabric_type", this.fabrictype);
        console.log("story_name", this.style_details.story_name);
        data.append("style_description", this.style_details.style_description);
        data.append("brand_id", this.style_details.brand_id);
        data.append("flag", this.flag);
        data.append("is_draft", this.selected_draft_value);
        data.append("size_details", JSON.stringify(main_arr));
        data.append("brand_manager", userInfo[0].brand_manager);
        data.append("pantone_no", this.temp_selected_pantone_no);
        data.append("panton_type", this.selected_panton_type);
        data.append("po_id", this.selected_po_id);
        data.append("solematerial", this.bottomfabrictype);
        data.append("materialinfoupperfabric", this.topfabrictype);
        data.append('material',this.material);
        data.append('pack_of',this.pack_of);
        data.append('is_epp',this.is_epp);
        data.append('style_comment', this.style_comment)
        data.append('upper_material',this.upper_material)
        data.append('inner_lining',this.inner_lining)
        data.append('sole',this.sole)
        data.append('surface_ornamentation',this.surface_ornamentation)
        data.append('highlight',this.highlight)
        data.append('Fastening_type',this.Fastening_type) 


        console.log("po_type_if", this.selected_po_id);
        
        // return false;
      } else {
        // alert("else");
        //let file = event.target.files[0];
        
          data.append("style_image", this.sytleImageurl);
       
          data.append("style_pdf", this.stylePdfUrl);
        data.append("style_pdf_image", this.style_pdf_image);
        data.append("sample_image", this.sampleImageurl);
        // data.append("style_pdf", this.stylePdfUrl);
        data.append("style_id", this.$route.params.id);
        data.append("style_name", this.style_details.style_name);
        data.append("updated_by", userInfo[0].email_id);
        if (this.selected_panton_type == 'OTHERS') {
          data.append("color", this.otherColor);
          console.log(" If color", this.otherColor);
          this.temp_selected_pantone_no = "";
          this.arraymerge = "";
        } else {
          data.append("color", this.temp_selected_pantone_no);
        }
        data.append("no_of_sizeset", 0);
        data.append("story_name", this.style_details.story_name);
        data.append("style_type", this.selected_style_type);
        data.append("fabric_type", this.fabrictype)
        console.log("story_name", this.style_details.story_name);
        data.append("style_description", this.style_details.style_description);
        data.append("brand_id", this.style_details.brand_id);
        data.append("flag", this.flag);
        data.append("size_details", JSON.stringify(main_arr));
        data.append("is_draft", this.selected_draft_value);
        data.append("pantone_no", this.temp_selected_pantone_no);
        data.append("panton_type", this.selected_panton_type);
        data.append("po_type", this.selected_po_id);
        console.log("po_type_else", this.selected_po_id);
        data.append("solematerial", this.bottomfabrictype);
        data.append("materialinfoupperfabric", this.topfabrictype);
        data.append('material',this.material);
        data.append('pack_of',this.pack_of);
        data.append('is_epp',this.is_epp);
        data.append('style_comment', this.style_comment)
        data.append('upper_material',this.upper_material)
        data.append('inner_lining',this.inner_lining)
        data.append('sole',this.sole)
        data.append('surface_ornamentation',this.surface_ornamentation)
        data.append('highlight',this.highlight)
        data.append('Fastening_type',this.Fastening_type) 

        // return false;
      }
      // console.log("Data",data);
      // console.log("config",config);
      // return false

  

      axios
        .post(`${CONSTANTS.API_URL}/updatestyle`, data, {
          header: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function(progressEvent) {
            this.progress1 = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          }.bind(this),
        })
        .then((response) => {
          this.progress1 = Math.round((100 * response.loaded) / response.total);
          document.getElementById("overlay").style.display = "none";

          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.sizeset = [];
            this.$fire({
              text: "Updated Successfully.",
              type: "success",
              timer: 30000,
            });
            document.getElementById("progress_bar1").style.display = "none";

            this.editdesign = false;
            this.customer = {};
            this.invoice_products = [
              {
                unit: [],
                selectedfromage: [],
                selectedtoage: [],
              },
            ];
            this.getdesigndetail();
            // this.$router.push(`/design_details/${this.$route.params.id}`)
            // this.$router.go()
            this.isSidebarRefresh=!this.isSidebarRefresh
            console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~", this.isSidebarRefresh)
          } else {
            this.$fire({
              text: this.result.returnvalue,
              type: "error",
              timer: 30000,
            });
          }
        })

        .catch((e) => {
          this.errors.push(e);
        });

      //}
    },
    //Update Collection Code Ends

    editdesigncancel: function() {
      this.customer = {};
      // this.sytleImageurl = '';
      this.style_type = [];
      this.fabrictype = [];
      this.editdesign = false;
      this.file=null;
      this.file1=null;
    },

    activitylogcancel: function() {
      this.customer = {};
      this.activitylogModel = !this.activitylogModel;
    },
    activitydetailscancel: function() {
      this.activitydetailsModel = !this.activitydetailsModel;
    },
    commentcancel: function() {
      this.customer = {};
      this.addcommentModel = !this.addcommentModel;
    },

    //Code Added by Sachin
    //Code for Edit Design
    changedesign: function(value) {
      this.editdesign = !this.editdesign;
    },

    activitylog: function(value) {
      this.activitylogModel = !this.activitylogModel;
    },
    //Code End For Edit Design
    addcomment: function(value) {
      this.comment = "";
      this.status = "";
      this.addcommentModel = !this.addcommentModel;
    },

    upload(event) {
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      let data = new FormData();
      // let file = event.target.files[0];
      data.append("file", this.sytleImageurl);
      data.append("style_id", this.$route.params.id);
      let config = {
        header: {
          "Content-Type": "multipart/form-data",
        },
      };

      if (
        this.sytleImageurl.type == "image/jpeg" ||
        this.sytleImageurl.type == "image/png"
      ) {
        axios
          .post(`${CONSTANTS.API_URL}/uploaddesignimage`, data, config)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.style_image = response.data.url;
            this.style_details.style_image = this.style_image;
          })
          .catch((err) => {
            return new Error(err.message);
          });
      } else {
        // alert("Please Select JPG or PNG Format Image Only");
        this.$fire({
          text: "Please Select JPG or PNG Format Image Only.",
          type: "warning",
          timer: 30000,
        });
        this.style_image = "";
        this.sytleImageurl = "";
      }
    },
    //new ends
    //Table Set Function
    opentable: function() {
      this.opentablemodel = !this.opentablemodel;
    },
    opentablecancel: function() {
      this.opentablemodel = !this.opentablemodel;
    },

    uploadImage(imgname, imgtype) {
      const { image } = this;
      const Obj = {
        style_id: this.$route.params.id,
        style_image: image,
      };
      axios
        .post(`${CONSTANTS.API_URL}/uploaddesignimage`, Obj)
        .then((response) => {
          this.style_image = response.data.url;

          this.style_details.style_image = this.style_image;
        })
        .catch((err) => {
          return new Error(err.message);
        });
    },

    removeImage: function(e) {
      this.upload_image = "";
    },
    //Code for Image Ends
    //Code Ends
    //Code Ends

    // Image uplod in drft

    AddDesignimagedraft(event){
      
      this.progress = 0;
      document.getElementById("progress_bar").style.display = "block";
      let file = event.target.files[0];
      this.sytleImageurl = file;
      console.log("TEST", this.sytleImageurl);
      this.selectFiletype = event.target.files[0].type;
      console.log("selectFiletype", this.selectFiletype);
      // this.styleImage();
      const regex = /[!@#$%^&*(),?"';:{}|<>\s]/g;
      let filename = file.name;
      this.container.filename = filename.replace(regex, "_");
      this.container.file = file;
      document.getElementById("overlay").style.display = "none";
      this.handleUpload();
    },

     // upload large file code starts
    async handleUpload() {
      if (!this.container.file) return;

      document.getElementById("overlay").style.display = "block";
      try {
        const fileChunkList = this.createFileChunk(this.container.file);
        this.container.hash = await this.calculateHash(fileChunkList);

        const { shouldUpload, uploadedList } = await this.verifyUpload(
          this.container.file.name,
          this.container.hash
        );
        if (!shouldUpload) {
          this.$fire({
            text: "Error In File Upload",
            type: "warning",
            timer: 30000,
          });
          return;
        } else {
          this.data = fileChunkList.map(({ file }, index) => ({
            fileHash: this.container.hash,
            index,
            hash: this.container.hash + "-" + index,
            chunk: file,
            size: file.size,
            percentage: uploadedList && uploadedList.includes(index) ? 100 : 0,
          }));

          console.log("uploading chunks----------------------------->");
          await this.uploadChunks(uploadedList);
        }
      } catch (err) {
        console.log("handleUpload err------------->" + err);
        document.getElementById("overlay").style.display = "none";
        this.$fire({
          text: "Error in file upload",
          type: "error",
          timer: 30000,
        });
      }
    },

        // xhr request
    request({
      url,
      method = "post",
      data,
      headers = {},
      onProgress = (e) => e,
      requestList,
    }) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.upload.onprogress = onProgress;
        xhr.open(method, url);
        Object.keys(headers).forEach((key) =>
          xhr.setRequestHeader(key, headers[key])
        );
        xhr.send(data);
        xhr.onload = (e) => {
          // remove xhr which status is success
          if (requestList) {
            const xhrIndex = requestList.findIndex((item) => item === xhr);
            requestList.splice(xhrIndex, 1);
          }
          resolve({
            data: e.target.response,
          });
        };
        // export xhr
        // requestList?.push(xhr);
        if (requestList) requestList.push(xhr);
      });
    },

    // create file chunk
    createFileChunk(file, size = SIZE) {
      const fileChunkList = [];
      let cur = 0;
      while (cur < file.size) {
        fileChunkList.push({ file: file.slice(cur, cur + size) });
        cur += size;
      }
      return fileChunkList;
    },

    // use web-worker to calculate hash
    calculateHash(fileChunkList) {
      return new Promise((resolve) => {
        this.container.worker = new Worker("/hash.js");
        this.container.worker.postMessage({ fileChunkList });
        this.container.worker.onmessage = (e) => {
          const { percentage, hash } = e.data;
          if (hash) {
            resolve(hash);
          }
        };
      });
    },

    // verify that the file has been uploaded based on the hash
    // skip if uploaded
    async verifyUpload(filename, fileHash) {
      
      const { data } = await this.request({
        url: `${CONSTANTS.API_URL}/verifyFileUpload`,
        headers: {
          "content-type": "application/json",
        },
        data: JSON.stringify({
          filename,
          fileHash,
        }),
      });
      return JSON.parse(data);
    },

    // upload chunks and filter uploaded chunks
    async uploadChunks(uploadedList = []) {
      try {
        document.getElementById("overlay").style.display = "block";
        const requestList = this.data
          .filter(({ hash }) => !uploadedList.includes(hash))
          .map(({ chunk, hash, index }) => {
            console.log("chunk------------------------------>");
            console.log(chunk);
            const formData = new FormData();
            formData.append("chunk", chunk);
            formData.append("hash", hash);
            formData.append("filename", this.container.filename);
            formData.append("fileHash", this.container.hash);
            formData.append("filetype", this.container.filetype);
            return { formData, index };
          })
          .map(({ formData, index }) =>
            this.request({
              url: `${CONSTANTS.API_URL}/uploadFileChunk`,
              data: formData,
              // onProgress: this.createProgressHandler(this.data[index]),
              requestList: this.requestList,
            })
          );
        await Promise.all(requestList);
        // merge chunks when the number of chunks uploaded before and
        // the number of chunks uploaded this time
        // are equal to the number of all chunks
        if (uploadedList.length + requestList.length === this.data.length) {
          document.getElementById("overlay").style.display = "none";
          await this.mergeRequest();
        }
      } catch (err) {
        console.log("uploadChunks err-------------------->");
        document.getElementById("overlay").style.display = "none";
      }
    },

    // notify server to merge chunks
    async mergeRequest() {
      // console.log("<<<<<<<<<<<<<<<<<<<<<<<<<")
      // console.log(this.sytleImageurl)
      document.getElementById("overlay").style.display = "block";
      let mergeResult = await this.request({
        url: `${CONSTANTS.API_URL}/mergeFileChunk`,
        headers: {
          "content-type": "application/json",
        },
        data: JSON.stringify({
          size: SIZE,
          fileHash: this.container.hash,
          filename: this.container.filename,
          filetype: this.container.file.type,
        }),
      });

      let mergeResultData = JSON.parse(mergeResult.data);
      console.log("merge result----------------------->");
      console.log(mergeResult);
      
      console.log(mergeResultData);
      if (mergeResultData.result == "success") {
        console.log("<<<<<<<<<<<<<<<<<<<<<<<<<") 
        this.sytleImageurl = mergeResultData.image_url;
        console.log(this.sytleImageurl)
        this.stylePdfUrl = mergeResultData.pdf_url;
        document.getElementById("overlay").style.display = "none";
        this.$fire({
          text: "Files Uploaded Successfully!",
          type: "success",
          timer: 30000,
        });
        document.getElementById("progress_bar").style.display = "none";
      } else {
        this.sytleImageurl = "";
        this.stylePdfUrl = "";
        document.getElementById("overlay").style.display = "none";
        this.$fire({
          text: "Error in uploading style image!",
          type: "error",
          timer: 30000,
        });
      }
    },
    // upload large file code ends


    //code for preview image
    previewImage(event) {
      console.log(event);
      document.getElementById("progress_bar").style.display = "block";
      this.temp_file = event.target.files[0];
      this.progress = 0;
      this.sytleImageurl = event.target.files[0];
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      let data = new FormData();
      // let file = event.target.files[0];
      data.append("file", this.sytleImageurl);
      // data.append('user_id',userInfo[0].user_id)
      // data.append('design_id',this.$route.params.id)
      let config = {
        header: {
          "Content-Type": "multipart/form-data",
        },
      };

      //code for progressbar
      this.progress = 0;
      this.currentFile = this.sytleImageurl;
      //code for progressbar
      document.getElementById("overlay").style.display = "block";
      if (this.sytleImageurl != undefined) {
        axios
          .post(`${CONSTANTS.API_URL}/pdfToImage`, data, {
            header: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: function(progressEvent) {
              this.progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            }.bind(this),
          })
          .then((response) => {
            this.progress = Math.round(
              (100 * response.loaded) / response.total
            );
            document.getElementById("overlay").style.display = "none";
            if (response.data.result == "success") {
              this.sytleImageurl = response.data.image_url;
              this.style_pdf_image = response.data.image_url;

              this.stylePdfUrl = response.data.pdf_url;
              // alert("File Uploaded Successfully");
              this.$fire({
                text: "File Uploaded Successfully.",
                type: "success",
                timer: 30000,
              });
              document.getElementById("progress_bar").style.display = "none";
            } else {
              (this.sytleImageurl = ""),
                (this.stylePdfUrl = ""),
                (this.style_pdf_image = "");
            }
          })
          .catch((err) => {
            return new Error(err.message);
            (this.sytleImageurl = ""), (this.progress = 0);
            this.message = "Could not upload the file!";
            this.currentFile = "";
          });
      }
    },
    //code for preview image ends
    // Code for Sample Image
    AddSampleimage: function(event) {
      this.sampleFile = event.target.files[0];
      // console.log("Sample File",this.sampleFile);
      this.sampleImage();
    },

    sampleImage: function() {
      document.getElementById("overlay").style.display = "block";
      console.log("SSSSSSSSSS", this.sampleFile);
      // return false;
      // this.sytleImageurl = event.target.files[0];
      let data = new FormData();
      let config = {
        header: {
          "Content-Type": "multipart/form-data",
        },
      };
      data.append("file", this.sampleFile);
      axios
        .post(`${CONSTANTS.API_URL}/uploadfiletos3`, data, {
          header: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log("HHHHHH", response);
          document.getElementById("overlay").style.display = "none";
          if (response.data.result == "success") {
            // document.getElementById("overlay").style.display = "none";
            this.sampleImageurl = response.data.image_url;
            console.log("SFSFSFS", this.sampleImageurl);
            this.file1 = "";
          } else {
            this.sampleImageurl = "";
            this.file1 = "";
          }
        });
    },
    // End
    // Function For Action on status
    updatestylestatus: function(comment, value) {

        console.log("this.selected_Grade------------->", this.selected_Grade)

      if((this.selected_Grade == '' || this.selected_Grade == null) && (this.user_type !='Admin' && this.status == 'approved') && (this.user_type !='Buying_Head' && this.status == 'approved'))
      {
           this.$fire({
                text: "Please select grade for the style",
                type: "warning",
                timer: 30000,
              });

      }
      else{
        document.getElementById("overlay").style.display = "block";
        var status = value;
        var comment = comment;
        var userData = localStorage.getItem("userData");
        var userInfo = JSON.parse(userData);
        var user_id = userInfo[0].user_id;

        if (status != "") {
            const Obj = {
            operational_status: status,
            updated_by: userInfo[0].email_id,
            user_id: userInfo[0].user_id,
            style_id: this.route_id,
            comments: comment,
             grade: this.selected_Grade
            };
            axios
            .post(`${CONSTANTS.API_URL}/updatestylestatus`, Obj)
            .then((response) => {
                document.getElementById("overlay").style.display = "none";
                this.result = response.data;
               
                if (this.result.returnmsg == "Successful") {
                // alert("Status Updated Successfully");
                // this.$fire({
                //   text: "Status Updated Successfully.",
                //   type: "success",
                //   timer: 30000,
                // });
                if(userInfo[0].user_type != 'Brand_Manager'){
                let brandName = JSON.parse(localStorage.getItem('selectedBrandId')).target.value.split('+');
                const emailObj = {
                    style_code: this.result.returnvalue[0].style_code,
                    brand_name: brandName,
                    designer_name: userInfo[0].full_name,
                    user_id: userInfo[0].user_id,
                }

                console.log("emailobj--------------------------->", emailObj);
                
                axios
                .post(`${CONSTANTS.API_URL}/addEmailTriggersDesignIsApproved`, emailObj)
                .then((response) => {
                    document.getElementById("overlay").style.display = "none";
                    if(response.data.returnmsg == "Successful"){
                        if(this.status == 'approved')
                        {
                          this.$fire({
                            text: "Status Updated Successfully and email has been sent",
                            type: "success",
                            timer: 30000,
                        });

                        } else{
                          this.$fire({
                                text: "Status Updated Successfully",
                                type: "success",
                                timer: 30000,
                          });
                        }  
                  
                    }
                    else{
                        this.$fire({
                        text: response.data.returnvalue,
                        type: "warning",
                        timer: 30000,
                    });
                    }
                  }).catch((e) => {
                    this.errors.push(e);
                  });
                }
                else{
                  this.$fire({
                              text: "Status Updated Successfully",
                              type: "success",
                              timer: 30000,
                        });
                }
                
                this.block_status = false;
                this.addcommentModel = false;
                // this.sizeset=[];
                // this.$router.push('/style_list');
                // this.$router.push({ name: 'style_list', params: { id: "Designs_Pending_For_Approval" } })
                // this.$router.push({ path: `/design_quotes/'Designs_Pending_For_Approval'` })
                // if(this.user_type != 'Buying_Head'){
                //   this.$router.push({
                //       path: `/style_list/${"Designs_Pending_For_Approval"}`,
                //   });
                //   this.getdesigndetail();
                // }else if(this.user_type != 'Buyer'){
                //   this.$router.push({
                //       path: `/style_list/Buying_Head-approved`,
                //   });
                //   this.getdesigndetail();
                // }
                // else{
                //   this.$router.go(-1);
                // }
                this.$router.go(-1);
                // this.router.go(0);
                
                } 

                else {
                // alert("Please Check Status");
                this.$fire({
                    text: "Please Check Status",
                    type: "warning",
                    timer: 90000,
                });
                }
            

            })
            .catch((e) => {
                this.errors.push(e);
            });
        } else {
            document.getElementById("overlay").style.display = "none";
            this.$fire({
            text: "Please Check Status",
            type: "warning",
            timer: 900000,
            });
        }

        }
    },

    /****** Function to design details ********/
    getdesigndetail: function() {
      // document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      this.access_token = userInfo[0]["token"];
      axios.defaults.headers.common["x-access-token"] = this.access_token;
      axios.defaults.headers.common["Content-Type"] =
        "application/json;charset=UTF-8";
      axios.defaults.headers.common["Accept"] = "application/json";
      axios.defaults.headers.common["Origin"] = "http://localhost:8080";
      this.isBusy = true;

      const Obj = {
        style_id: this.$route.params.id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getdesigndetail`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.style_details = this.result.returnvalue[0];
            console.log('  this.style_details @@@@@@@@@@@@@@@@@@@@@@@@',  this.style_details );
            this.selected_sub_catid = this.style_details.sub_catid;
            console.log('this.selected_sub_catid ',this.selected_sub_catid);
            this.sytleImageurl = this.style_details.style_image;
            this.selected_color_family = this.style_details.color_family;
            this.selected_pantone_no = this.style_details.color;

            this.selected_panton_type = this.style_details.panton_type;
            this.temp_color = this.style_details.color;
            this.selected_mutlicolor = this.style_details.color.split(",")
            console.log("~~~~~~~~~~~!!!!!!!!!!!!!!!!~~~~~~~~~~~~~~~~~~~~")
            this.upper_material = this.style_details.upper_material;
            this.inner_lining = this.style_details.inner_lining;
            this.sole =   this.style_details.sole;
            this.surface_ornamentation = this.style_details.surface_ornamentation;
            this.highlight = this.style_details.highlight;
            this.Fastening_type =   this.style_details.fastening_type;
            console.log(this.selected_mutlicolor)
            this.temp_sizeset = this.style_details.no_of_sizeset;
            this.temp_story_name = this.style_details.story_name;
            console.log("PPPPPPPPPPPPPPPPPpp", this.style_details.size_details);
            var from_age = this.style_details.size_details[0].selectedfromage ? this.style_details.size_details[0].selectedfromage : '';
            var to_age = this.style_details.size_details[0].selectedtoage ? this.style_details.size_details[0].selectedtoage : '';
            var unit = this.style_details.size_details[0].unit ? this.style_details.size_details[0].unit :'';
            localStorage.setItem('unit', JSON.stringify(unit));
            var temp_length = from_age.length;

            this.range_selectedtoage = parseInt(from_age[0]) + temp_length - 1;
            for (var i = 0; i <= from_age.length; i++) {
              this.range_selectedfromage = parseInt(from_age[0]);
              this.range_selected_month = parseInt(unit[0]);
            }

            this.selected_sizeset = this.style_details.no_of_sizeset;
            // this.sizeset=this.style_details.no_of_sizeset;
            this.selected_design_id = this.style_details.design_id;
            this.getDesignSampleList(this.selected_design_id);

            for (var i = 1; i <= this.style_details.no_of_sizeset; i++) {
              this.sizeset.push(i);
              // alert("In")
            }
            console.log("TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT", this.sizeset);
            this.temp_style_description = this.style_details.style_description;
            this.temp_style_name = this.style_details.style_name;
            this.temp_style_image = this.style_details.style_image;

            this.fileObj_msg = this.result.returnvalue[1].file_name;

            this.selected_status_code_number = this.style_details.status_code_number;
            this.totalRows = this.result.returnvalue.length;

            // console.log("########################",this.style_details.size_details[0].quantity[0])
            // alert("kkkkkk1111");

            console.log(
              "{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{{",
              this.style_details.pantone_no
            );
            this.getselectedfamilycolor(this.selected_panton_type);
            this.setSelectedcolor(this.style_details.pantone_no, 0);
            //Added New Code
            this.temp_sizeset = this.style_details.no_of_sizeset;
            if(this.style_details && this.style_details.size_details && this.style_details.size_details[0]){
            if (this.style_details.size_details[0].unit.length != 0) {
              for (
                let i = 0;
                i < this.style_details.size_details[0].unit.length;
                i++
              ) {
                var temp_selected_unit = this.style_details.size_details[0]
                  .unit;
              }
              console.log("temp_selected_unit", temp_selected_unit);
            }
            if ( this.style_details.size_details[0].selectedfromage &&
              this.style_details.size_details[0].selectedfromage.length != 0
            ) {
              for (
                let i = 0;
                i < this.style_details.size_details[0].selectedfromage.length;
                i++
              ) {
                var temp_selected_fromage = this.style_details.size_details[0].selectedfromage ? this.style_details.size_details[0].selectedfromage  : '';
                console.log("temp_selected_fromage", temp_selected_fromage);
              }
            }
            if ( this.style_details.size_details[0].selectedtoage && this.style_details.size_details[0].selectedtoage.length != 0) {
              for (
                let i = 0;
                i < this.style_details.size_details[0].selectedtoage.length;
                i++
              ) {
                var temp_selected_toage = this.style_details.size_details[0]
                  .selectedtoage;
                console.log("temp_selected_toage", temp_selected_toage);
              }
            }

            if (this.style_details.size_details[0].quantity && this.style_details.size_details[0].quantity.length != 0) {
              for (
                let i = 0;
                i < this.style_details.size_details[0].quantity.length;
                i++
              ) {
                var temp_qty = this.style_details.size_details[0].quantity[0];
                console.log("temp_qty", temp_qty);
              }
            }

            if (this.style_details.size_details[0].factorysize && this.style_details.size_details[0].factorysize.length != 0) {
              for (
                let i = 0;
                i < this.style_details.size_details[0].factorysize.length;
                i++
              ) {
                var temp_factorysize = this.style_details.size_details[0]
                  .factorysize[0];
                console.log("temp_factorysize", temp_factorysize);
              }
            }

            if (this.style_details.size_details[0].mrp && this.style_details.size_details[0].mrp.length != 0) {
              for (
                let i = 0;
                i < this.style_details.size_details[0].mrp.length;
                i++
              ) {
                var temp_mrp = this.style_details.size_details[0]
                  .mrp[0];
                console.log("temp_mrp", temp_mrp);
              }
            }

            if (this.style_details.size_details[0].uk && this.style_details.size_details[0].uk.length != 0) {
              for (
                let i = 0;
                i < this.style_details.size_details[0].uk.length;
                i++
              ) {
                var temp_uk= this.style_details.size_details[0].uk;
              }
            }


            if (this.style_details.size_details[0].us && this.style_details.size_details[0].us.length != 0) {
              for (
                let i = 0;
                i < this.style_details.size_details[0].us.length;
                i++
              ) {
                var temp_us= this.style_details.size_details[0].us;
              }
            }

            if (this.style_details.size_details[0].foot_length_cm && this.style_details.size_details[0].foot_length_cm.length != 0) {
              for (
                let i = 0;
                i < this.style_details.size_details[0].foot_length_cm.length;
                i++
              ) {
                var temp_foot_length_cm= this.style_details.size_details[0].foot_length_cm;
              }
            }

            if (this.style_details.size_details[0].brand_size_euro && this.style_details.size_details[0].brand_size_euro.length != 0) {
              for (
                let i = 0;
                i < this.style_details.size_details[0].brand_size_euro.length;
                i++
              ) {
                var temp_brand_size_euro= this.style_details.size_details[0].brand_size_euro;
              }
            }
            this.unit = temp_selected_unit;
            this.selectedfromage = temp_selected_fromage ? temp_selected_fromage : '';
            this.selectedtoage = temp_selected_toage ? temp_selected_toage :'';
            this.quantity = temp_qty ? temp_qty :'';
            this.factorysize = temp_factorysize ? temp_factorysize :'';
            this.uk =temp_uk ? temp_uk:'';
            this.us = temp_us ? temp_us :'';
            this.foot_length_cm = temp_foot_length_cm ? temp_foot_length_cm: '';
            this.brand_size_euro = temp_brand_size_euro ? temp_brand_size_euro:'';


            if(this.style_details && this.style_details.size_details[0] && this.style_details.size_details[0].mrp)
            {
                this.total_mrp = temp_mrp ? temp_mrp :'' 
            }   
            //Added New Code Ends
            }
            this.totalRows = this.result.returnvalue.length;
          } else {
            this.style_details = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        });
      // .catch(e => {
      //   this.errors.push(e)
      // })
    },

    /****** Function to Get Design Sample List ********/
    getDesignSampleList: function(value) {
      this.isBusy = true;
      const Obj = {
        design_id: value,
      };

      axios
        .post(`${CONSTANTS.API_URL}/getstylesamplelist`, Obj)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.nav_design_list = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;

            this.isBusy = !this.isBusy;
          } else {
            this.design_list = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    /******Function To Get PO Type List********/
    getPoTypeList: function() {
      // document.getElementById("overlay").style.display = "block";

      // this.isBusy = true;
      const Obj = {
        subcat_id: this.sub_catid,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getPoTypeList`, Obj)
        .then((response) => {
          // document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            this.po_typearr = this.result.returnvalue;
            // this.totalRows = this.result.returnvalue.length;
            // this.isBusy = !this.isBusy;
          } else {
            this.po_typearr = [];
            // this.totalRows=0;
            // this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    /******Function To Get PO Type List Ends********/

    /*********Function to get utility type start***************/
    getUtilityTypeList: function(){

       const Obj = {
        subcat_id: this.sub_catid,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getUtilityTypeList`, Obj)
        .then((response) => {
          // document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            this.utility_typearr = this.result.returnvalue;
            console.log("this.utility_typearr",this.utility_typearr)
        
          } else {
            this.utility_typearr = [];
          
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });

    },

    getSubCategory(categoryId){
      this.selected_sub_catid = categoryId
    },

    /*********Function to get utility type ends***************/

    /****** Function to design summary ********/
    getfileslisting: function() {
      this.isBusy = true;
      const Obj = {
        design_id: this.$route.params.id,
      };

      axios
        .post(`${CONSTANTS.API_URL}/getdesignfilelist `, Obj)
        .then((response) => {
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.files_list = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;

            this.isBusy = !this.isBusy;
          } else {
            this.files_list = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    fabrictypefunation : function(){
        // alert();
        const Obj={
          subcat_id: this.sub_catid,
          brand_id: this.brandid,
          // style_id: this.selected_style_id
        }
        axios.post(`${CONSTANTS.API_URL}/getFabricTypeList`,Obj)
           .then(response => {

            document.getElementById("overlay").style.display = "none";
             this.result = response.data;
             if (this.result.returnmsg === 'Successful') {
              //  this.fabric_arr=this.result.returnvalue[0].Fabric;
               console.log("PPPPPPPPtttttttttttttttttPPPPPPPPPPPP",this.result.returnvalue[0].Fabric)
               this.fabrictype_arr = this.result.returnvalue[0].FabricType;
               this.bottom_fabric_arr = this.result.returnvalue[0].Bottom_Fabric_Sole_Material;
               this.top_fabric_arr = this.result.returnvalue[0].Top_Fabric_Upper_Fabric;
               console.log("EEEEEEEEEEEEEEEEEEE",this.fabrictype_arr);
              
             }else {
              this.fabrictype_arr =[]
             
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })      

      
       },

        // Remove color
    removecolor(index){
      console.log(index)
      this.selected_final_color.splice(index,1)
      console.log("**************************")
      console.log(this.selected_final_color)
    },

    removeselectedcolor(index){
      // alert()
      // this.selected_mutlicolor.splice(index,1)   
       console.log(index)
      this.selected_mutlicolor.splice(index,1)
      console.log("**************************")
      console.log(this.selected_mutlicolor)   

    },

    /****** Function to Get Brand & Segments ********/
    getBrandSegmentList:function(){
      document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      if (userData) {
        var userInfo = JSON.parse(userData);
        this.user_id = userInfo[0].user_id;
        this.brand_assign = userInfo[0].brand_assign;
        if (userInfo[0].user_type == "Brand_Manager") {
          this.selected_brand_manager = userInfo[0].user_id;
        } else {
          this.selected_brand_manager = userInfo[0].brand_manager;
        }
        var obj = {
          user_id: this.user_id,
          selected_brand: this.brand_assign,
          brand_manager: this.selected_brand_manager,
        };

        axios
          .post(`${CONSTANTS.API_URL}/getBrandSegmentList`, obj)
          .then((response) => {
           
            this.result = response.data;
            if (this.result.returnmsg === "Successful") {
              document.getElementById("overlay").style.display = "none";
              this.segmentarray_list = this.result.returnvalue[0]['segment_list'];
               this.segmentList_arr = this.result.returnvalue;
              this.totalRows = this.segmentList_arr[0]["segment_list"].length;

              if (this.totalRows > 0) {
                this.segment_id = this.segmentList_arr[0]["segment_list"][0][
                  "segment_id"
                ];
                this.brand_id = this.segmentList_arr[0]["segment_list"][0][
                  "brand_id"
                ];
                this.showCollection(this.brand_id, this.segment_id);
              }

            }
            else{
              this.segmentList_arr = [];
              this.totalRows = 0;
            }
          })
           .catch((e) => {
            this.errors.push(e);
          });

      }
    },


    // Collection list accorfing to segment selected
     showCollection(brand_id, segment_id) {
      document.getElementById("overlay").style.display = "block";
      this.collection_brand_id = brand_id;
      this.collection_segment_id = segment_id;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      var user_id = userInfo[0].user_id;

      const Obj = {
        brand_id: brand_id,
        segment_id: segment_id,
        user_id:  userInfo[0].user_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getSegmentCollectionList`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          if (response.data.returnmsg == "Successful") {

             this.collectionData = response.data.returnvalue.collections;
             console.log("collections");
             console.log(this.collectionData)
          }else{
            this.collectionData = []
          }
        })
         .catch((e) => {
            this.errors.push(e);
          });
    
    },


    getDesignDetailsModel(details){
       console.log("details")
      console.log(details)
      this.getdesigndetail();
      this.style_id = details.style_id,
      this.sub_catid = details.sub_catid;
      this.brandid = details.brand_id;
      this.selected_po_id = details.po_id;
      this.selected_utility_id = details.utility_id;
      this.selected_segment_id = details.segment_id;
      this.selected_categoryId = details.category_id;
      this.selected_collection_id = details.collection_id;
      console.log("this.selected_collection_id",this.selected_collection_id)
      this.selected_style_type = details.style_type;
      this.fabrictype = details.fabrictype;
      this.selected_panton_type = details.panton_type;
      this.topfabrictype = details.materialinfoupperfabric
      this.bottomfabrictype = details.solematerial
      this.material = details.material
      this.pack_of = details.pack_of
      this.is_epp = details.is_epp
      this.style_comment = details.style_comment
      // alert(this.selected_panton_type)
      this.selected_mutlicolor = details.color.split(",")
      console.log("~~~~~~~~~~~!!!!!!!!!!!!!!!!~~~~~~~~~~~~~~~~~~~~")
      console.log(details.materialinfoupperfabric, details.solematerial)
      this.otherColor = details.color;
      this.design_id = details.design_id
      // alert(this.otherColor )
      this.getPoTypeList();
      this.getUtilityTypeList();
      this.fabrictypefunation();
      this.getBrandSegmentList();
      this.designDetailsModel = true;

    },

    designDetailsModelcancel(){
       this.style_details.story_name = ""
          this.style_details.design_hit = ""
          this.style_details.style_description = ""
          this.otherColor = ""
      this.designDetailsModel = false;
     
    },
   
   validateUpdateDesignDetails(scope) {
    console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx');
      this.$validator.validateAll(scope).then(result => {
        if (result) {   
          console.log('jjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjj');
          this.updatetechpackdetails();
          
        }
      });
    },

    updatetechpackdetails(){
      document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);

      if(this.selected_mutlicolor.length != 0){
        console.log(".........................................")
      const concatarraytemo = this.selected_final_color.concat(this.selected_mutlicolor)
      this.arraymerge = [...new Set(concatarraytemo)];
      console.log("for multi color",this.arraymerge);

      }
      else{
        this.arraymerge = this.selected_final_color
        console.log("..........removed previous data...............")
        //  console.log(this.arraymerge);
      }

      if (this.selected_panton_type == 'OTHERS') {
        this.selected_color = this.otherColor
        console.log(" If color", this.selected_color);
        this.temp_selected_pantone_no = "";
        this.arraymerge = "";
      } else {
        this.selected_color =  this.arraymerge.toString()
        console.log(" else color", this.selected_color);
      }

      // if(this.selected_panton_type != "OTHERS"){

      //   this.selected_color = this.selected_final_color 

      // }else{
      //   this.selected_color = this.otherColor;
      // }
      
      const Obj={
          style_id : this.style_id,
          updated_by: userInfo[0].email_id,
          story_name: this.style_details.story_name,
          style_type: this.selected_style_type ,
          fabric_type:  this.fabrictype ,
          solematerial: this.bottomfabrictype,
          materialinfoupperfabric: this.topfabrictype,
          style_description: this.style_details.style_description,
          panton_type: this.selected_panton_type,
          po_id: this.selected_po_id ,
          utility_type: this.selected_utility_id,
          design_id: this.design_id,
          segment_id: this.selected_segment_id,
          sub_category_id: this.sub_catid,
          category_id : this.selected_categoryId,
          collection_id : this.selected_collection_id,
          // design_hit : this.style_details.design_hit,
          color: this.selected_color,
          user_type: userInfo[0].user_type,
          buyer_id: userInfo[0].user_id,
          material: this.material,
          pack_of : this.pack_of,
          is_epp : this.is_epp,
          style_comment : this.style_comment,
          upper_material:  this.upper_material,
          inner_lining: this.inner_lining,
          sole: this.sole,
          surface_ornamentation: this.surface_ornamentation,
          highlight: this.highlight,
          Fastening_type: this.Fastening_type
           
      }

      console.log('Obj',Obj);

      axios
        .post(`${CONSTANTS.API_URL}/updateTechPackDetailsForBuyer`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          if (response.data.returnmsg == "Successful") {
               this.$fire({
                text: "Data Updated Successfully",
                type: "success",
                timer: 30000,
              });
              this.getdesigndetail();
              this.designDetailsModel = false;

          }else{
            this.$fire({
                  text: response.data.returnvalue,
                  type: "error",
                  timer: 30000,
                });
              this.getdesigndetail();
              this.designDetailsModel = false;

          }
        }).catch((e) => {
            this.errors.push(e);
          });
    },

    deleteStyleData(styleid)
    {
      document.getElementById("overlay").style.display = "block";
      const obj = {
          style_id : styleid
      }
      console.log(obj) 
      axios
        .post(`${CONSTANTS.API_URL}/deleteStyle`, obj)
        .then((response) => {
          console.log("deletestyle", response.data)
          document.getElementById("overlay").style.display = "none";
          if (response.data.returnmsg == "Successful") {
            this.$fire({
                  text: "Style Deleted Successfully",
                  type: "success",
                  timer: 30000,
            });
            this.showDeleteStyleModel = false;
            this.$router.push('/dashboard_designer');
          }
        })
    },

    deleteStyle() {
      this.showDeleteStyleModel = true;
    },

    closedeletemodal() {
      this.showDeleteStyleModel = false;
    },

    
    selectGrade(){
        this.showGradeModal = true;
    },

    validategrade(){
        console.log("ddddddddddddddddddd",this.selected_Grade)
        this.showGradeModal = false;
    },

    cancelshowGradeModal(){
        this.selected_Grade =  null;
        this.showGradeModal = false;
    },
     handleDragEnterSample() {
    console.log("Drag Entered");
    this.isDraggingSample = true;
  },
  handleDragOverSample() {
    this.isDraggingSample = true;
  },
  handleDragLeaveSample() {
    this.isDraggingSample = false;
  },
  handleDropSample(e) {
    console.log("File Dropped",e);
    this.isDraggingSample = false;

    const droppedFile = e.dataTransfer.files[0];
    if (!droppedFile) return;

    // Only image allowed
    if (!droppedFile.type.startsWith("image/")) {
      this.$fire({
        text: "Only image files are allowed.",
        type: "warning",
        timer: 30000,
      });
      return;
    }

    this.file1 = droppedFile;
    this.AddSampleimage({ target: { files: [droppedFile] } });
  },

    handleDragEnterDesign() {
      this.isDraggingDesign = true;
    },
    handleDragOverDesign() {
      this.isDraggingDesign = true;
    },
    handleDragLeaveDesign() {
      this.isDraggingDesign = false;
    },

    handleDropDesign(e) {
      this.isDraggingDesign = false;

      const droppedFile = e.dataTransfer.files[0];
      if (!droppedFile) return;

      // Allowed formats
      const allowed = [
        "application/pdf",
        "image/png",
        "image/jpeg",
        "image/jpg"
      ];

      if (!allowed.includes(droppedFile.type)) {
       this.$fire({
          text: "Only PDF and image files are allowed.",
          type: "warning",
          timer: 30000,
        });
        return;
      }

      // Assign file & trigger your existing function
      this.file = droppedFile;
      this.AddDesignimagedraft({ target: { files: [droppedFile] } });
    }

  },
  watch: {
    $route() {
      this.route_id = this.$route.params.id;
      this.getdesigndetail();
    },
  },

  computed: {
  finalImage() {
    // if style_image exists → use it
    if (this.style_details.style_image) {
      return this.style_details.style_image;
    }
    // else fallback to sample_image
    return this.style_details.sample_image;
  },

  finalImageType() {
    let img = this.finalImage;

    if (!img) return null;

    if (img.endsWith(".pdf")) return "other";

    // match png, jpg, jpeg
    if (/\.(png|jpg|jpeg)$/i.test(img)) return "image";

    return null;
  }
}

};
</script>
<style>
.short-div {
  height: 55px;
}

.quote-dropdowns .dropdown--accepted {
  border-top: 1px solid var(--fill-green-dark);
}

.quote-dropdowns > .card {
  background-color: var(--fill-white);
}
.quote-dropdowns .dropdown__header.dropdown__header--accepted {
  border: 1px solid var(--fill-green-dark);
  border-top: none;
  background-color: #e8fff5;
}
.card .card__section {
  flex-grow: 1;
  box-shadow: inset 0 -1px 0 0 #e5e5e5;
  box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .dropdown__header {
  align-items: center;
  justify-items: center;
  justify-content: center;
  cursor: pointer;
}
.quote-dropdowns .card__section {
  padding: 16px 32px;
}
.f-sz-l {
  font-size: 15px;
}
.flex-col {
  flex-direction: column;
}
.flex,
.flex-col {
  display: flex;
}
.f-w-semi-bold {
  font-weight: 600;
}
.f-sz-sm {
  font-size: 12px;
}
.f-w-semi-bold {
  font-weight: 600;
}

.card .card__section {
  flex-grow: 1;
  box-shadow: inset 0 -1px 0 0 #e5e5e5;
  box-shadow: inset 0 -1px 0 0 var(--fill-grey-light3);
}
.quote-dropdowns .card__section {
  padding: 16px 32px;
}

.input-grp {
  width: 100%;
  margin-bottom: 16px;
}
.input-grp {
  margin-bottom: 10px !important;
}

.input-grp label {
  margin-bottom: 6px;
  color: #333340;
}

input[type="number"],
input[type="password"],
input[type="tel"],
input[type="text"] {
  padding: 13px 12px;
  border-radius: 2px;
  border: 1px solid #bfbfbf;
}
.input-grp input,
.input-grp label,
.input-grp select {
  display: block;
  width: 100%;
}

.input-grp select:disabled {
  background-color: #ebebe4;
}
.input-grp select {
  background: url(/static/media/ic-arrow-drop-down.1f6abe65.svg) no-repeat;
  background-position: right 8px top 6px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}

.quote-dropdowns .dropdown__header.dropdown__header--accepted {
  border: 1px solid var(--fill-green-dark);
  border-top: none;
  background-color: #e8fff5;
}

.main_body {
  width: 970px;
}
/*.card-footer{
    border-radius: 0 0 15px 15px !important;
      border-top: 0 !important;
      background-color: #F5F5F5 !important;

  }*/
.container {
  align-content: center;
}
.search {
  border-radius: 15px 0 0 15px !important;
  background-color: white !important;
  border: 0 !important;
  color: white !important;
}
.search:focus {
  box-shadow: none !important;
  outline: 0px !important;
}
/*.type_msg{
      background-color: white !important;
      border:0 !important;
      color:white !important;
      height: 60px !important;
      overflow-y: auto;
    }*/
#type_msg:focus {
  box-shadow: none !important;
  outline: 0px !important;
}
.send_btn {
  border: 1 !important;
  border-color: #20a8d8;
  background-color: #4d94ff;
  cursor: pointer;
}
.search_btn {
  border-radius: #20a8d8 !important;
  border: 0 !important;
  background-color: #20a8d8;
  cursor: pointer;
}
.contacts {
  list-style: none;
  padding: 0;
}
.contacts li {
  width: 100% !important;
  padding: 5px 10px;
  margin-bottom: 15px !important;
}

.user_img {
  height: 40px;
  width: 30px;
  border: 1.5px solid #f5f6fa;
  margin-left: 10px;
}
.user_img_msg {
  height: 30px;
  width: 30px;
  border: 1.5px solid #f5f6fa;
}
.text-span {
  background: blue;
  border-radius: 50%;
  height: 26px;
  width: 26px;
  line-height: 26px;
  display: inline-block;
  text-align: center;
  margin-right: 6px;
}
.text-span2 {
  background: gray;
  border-radius: 50%;
  height: 26px;
  width: 26px;
  line-height: 26px;
  display: inline-block;
  text-align: center;
  margin-right: 6px;
}

/*.mb-4, .my-4 {
    margin-bottom: 0.5rem !important;
    position: absolute;
    top: 65px;
  }*/
/* #vendor_name{
    font-size: 16px;
    color: black;
    font-style: normal
  }*/

.msg_time_send {
  position: absolute;
  right: 0;
  bottom: -15px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 10px;
}
.msg_head {
  position: relative;
}
.brandcard {
  border-radius: 0px !important;
  padding-left: 10px !important;
}

.sidebar {
  background: #17a2b8 !important;
  width: 50px !important;
}

.sidebar .sidebar-nav {
  width: 50px !important;
}
.sidebar .nav {
  width: 50px !important;
}

.main1 {
  margin-left: 50px !important;
}
#rec_msg {
  margin-left: 40%;
  position: absolute;
}

/*****CSS For Zoom Image*****/
*body {
  margin: 0;
}
#btn_navbar {
  overflow: hidden;
  text-align: center;
  /*position: fixed;*/
  top: 0;
  width: 100%;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 20px;
}
#btn_navbar a {
  float: left;
  display: block;
  color: #666;
  text-align: center;
  padding-right: 20px;
  text-decoration: none;
  font-size: 17px;
}
#btn_navbar a:hover {
  background-color: #ddd;
  color: black;
}
#btn_navbar a.active {
  background-color: #4caf50;
  color: white;
}
.main1 {
  padding: 16px;
  margin-top: 30px;
}
.main1 img {
  max-width: 100%;
  height: auto;
}
.button {
  width: 300px;
  height: 60px;
}

/*****CSS For Zoom Image Ends*****/

/*** Tabb ***/
/*.header-tabs__navbar {
    margin-top: auto;
    align-items: center;
    border-top: 1px solid var(--fill-grey-light2);
    width: 100%;
}
.flex {
    display: flex;
}*/

/*.header-tabs__tab {
    position: relative;
    flex: 1 1;
    height: 60px;
    padding: 12px 24px;
    border-bottom: 3px solid var(--fill-grey-light3);
    display: flex;
    flex-direction: row;
    cursor: pointer;
    border:1px solid gray;
}*/

/*.header-tabs__tab-image {
    padding-right: 8px;
}

.header-tabs__tab-block {
    display: flex;

    flex-direction: column;
    justify-content: center;
}
 
.header-tabs__tab .sub_title {
    font-size: 12px;
    line-height: 16px;
    text-transform: capitalize;
    font-weight: 400;
    color: var(--fill-grey-medium);
}*/

html,
body {
  margin: 0;
}
.wrapper {
  display: flex;
  flex-direction: column;
  height: 92vh;
  width: 100%;
  background-color: white;
}
.header-tabs__tab {
  position: relative;
  flex: 1 1;
  height: 43px !important;
  padding: 12px 22px;
  border-bottom: 3px solid var(--fill-grey-light3);
  display: flex;
  flex-direction: row;
  cursor: pointer;
  border: 1px solid #63c2de;
  border-radius: 12px;
}

/*Todays CSS*/
.nav_row_tabs {
  display: flex;
  border-top: 1px solid #d7dbdd;
  border-bottom: 1px solid #d7dbdd;
}

.nav_tabs__tab--disabled {
  cursor: not-allowed !important;
  opacity: 0.6;
  pointer-events: none;
}

/*CSS 2710*/
.nav_tabs__tab--active:after {
  background: var(--fill-primary-blue);
}

.nav_tabs__tab-image {
  padding-right: 8px;
}
.nav_tabs__tab-block {
  display: flex;

  flex-direction: column;
  justify-content: center;
}
.nav_tabs__tab-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.nav_tabs__navbar {
  margin-top: auto;
  align-items: center;
  border-top: 1px solid #d7dbdd;
}
#activeTitle {
  font-size: 14px;
}
.viewClass {
  width: 190px;
}
.swal2-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px;
}
.selectedcolor {
  padding: 5px;
  text-align: center;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: rgb(255, 255, 255);
  /*background-color: rgb(119 119 119);*/
  background-color: rgba(255, 255, 255, 1);
  /*background-color: rgb(119 119 119,0.9);*/
  overflow-y: hidden;
  overflow: auto;
  transition: 0.5s;
}
.overlay .closebtn {
  position: absolute;
  top: 30px;
  right: 20px;
  font-size: 60px;
  color: #16a2d7;
}
.overlay-content {
  position: relative;
  top: 11%;
  right: 15px;
  width: 100%;
  text-align: center;
  margin-top: 30px;
  color: #bbbaba;
}
/*.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}*/
.overlay a {
  padding: 0px;
  text-decoration: none;
  font-size: 18px;
  color: #16a2d7;
  display: block;

  transition: 0.3s;
}
.overlay a:hover,
.overlay a:focus {
  color: #0864d6;
}
.design-list__item1 {
  height: 67px;
  padding: 12px 20px;
  padding-right: 6px;
  /*border-bottom: none !important;*/
  cursor: pointer;
}
.imgsidedesign {
  width: 20%;
  height: 100%;
  border-radius: 48%;
  border: 1px solid #e4e4e4;
}
@media screen and (max-width: 1170px) {
  .side {
    display: none;
  }
}
@media screen and (min-width: 1170px) {
  .navbtn {
    display: none;
  }
}
@media screen and (min-width: 1170px) {
  .closebtn {
    display: none;
  }
}
@media screen and (min-width: 320px) {
  .overlay {
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 1;
    top: 15px;
    left: 0;
    background-color: rgb(255, 255, 255);
    /*background-color: rgb(119 119 119);*/
    background-color: rgba(255, 255, 255, 1);
    /*background-color: rgb(119 119 119,0.9);*/
    overflow-y: hidden;
    overflow: auto;
    transition: 0.5s;
  }
  .overlay .closebtn {
    position: absolute;
    top: 30px;
    right: 20px;
    font-size: 30px;
    color: #16a2d7;
  }
  .overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 9px;
    color: #16a2d7;
    display: block;

    transition: 0.3s;
  }
  .f-sz-sm {
    font-size: 8px;
  }
  .design-list__subtitle1 {
    margin-left: 25px;
    border-bottom: 1px solid #e4e4e4;
  }
  .design-list__item1 {
    height: 56px;
    padding: 10px 21px;
    padding-right: 6px;
    border-bottom: 1px solid #d4d4d4;
    cursor: pointer;
  }

  .imgsidedesign {
    width: 61%;
    height: 100%;
    border-radius: 48%;
    border: 1px solid #e4e4e4;
  }
  .design-list__title1 {
    margin-left: 25px;
  }
}
@media screen and (min-width: 411px and min-width: 414px) {
  .overlay {
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 1;
    top: 15px;
    left: 0;
    background-color: rgb(255, 255, 255);

    background-color: rgba(255, 255, 255, 1);

    overflow-y: hidden;
    overflow: auto;
    transition: 0.5s;
  }
  .overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 11px;
    color: #16a2d7;
    display: block;

    transition: 0.3s;
  }
  .design-list__subtitle1 {
    border-bottom: 1px solid #e4e4e4;
  }
  .imgsidedesign {
    width: 61%;
    height: 100%;
    border-radius: 48%;
    border: 1px solid #e4e4e4;
  }
}
@media screen and (min-width: 1024px) {
  .overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 16px;
    color: #16a2d7;
    display: block;

    transition: 0.3s;
  }
  .overlay .closebtn {
    position: absolute;
    top: 30px;
    right: 20px;
    font-size: 45px;
    color: #16a2d7;
  }
  .design-list__title1 {
    margin-left: 55px;
    margin-bottom: 2px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
  }
  .design-list__subtitle1 {
    border-bottom: 1px solid #e4e4e4;
  }
  .imgsidedesign {
    width: 20%;
    height: 100%;
    border-radius: 48%;
    border: 1px solid #e4e4e4;
  }
}
@media screen and (min-width: 768px) {
  .overlay a {
    padding: 0px;
    text-decoration: none;
    font-size: 16px;
    color: #16a2d7;
    display: block;

    transition: 0.3s;
  }
  .overlay .closebtn {
    position: absolute;
    top: 30px;
    right: 20px;
    font-size: 45px;
    color: #16a2d7;
  }
  .design-list__title1 {
    margin-left: 55px;
    margin-bottom: 2px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
  }
  .design-list__subtitle1 {
    border-bottom: 1px solid #e4e4e4;
  }
  .imgsidedesign {
    width: 30%;
    height: 100%;
    border-radius: 48%;
    border: 1px solid #e4e4e4;
  }
}

.designtitle {
  margin-top: 0.625em;
  margin-bottom: 0.625em;
  width: 85%;
}
.dropdowndesign {
  float: right !important;
  margin-right: 0.625em !important;
}
.divdesign {
  float: left;
  border: 1px solid lightgray;
}
.imgdesign {
  padding: 0.3125em;
  height: 13.75em;
  width: 21.8125em;
}
.btndesign {
  padding: 0.3125em;
  margin-left: 30%;
}
.stylefield {
  font-size: 0.9375em !important;
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row wrap;
    justify-content: flex-start;
  }
}
@media (max-width: 320px) {
  .designtitle {
    /* margin-top:10px;
  margin-bottom:10px;*/
    width: 80%;
    font-size: 8px;
    padding: 5px;
  }
  .imgdesign {
    width: 90px;
    height: 80px;
  }
  .btndesign {
    padding: 1px;
    font-size: 9px;
    margin-top: 3px;
    margin-left: 25px;
  }
  .divdesign {
    float: left;
    border: 1px solid lightgray;
    height: 110px;
    margin-top: -50px;
    margin-bottom: 10px;
  }
  .stylefield {
    font-size: 10px !important;
  }
  .coldesign {
    flex: 0 0 100% !important;
    max-width: 85% !important;
  }
  .detailsrow {
    display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
  }
  .selectedcolor {
    padding: 5px;
    text-align: center;
    width: 50%;
  }

  /*.colonb{
  text-align: center;
  position: absolute;
  
}
.titleb{
   position: absolute;
   width: 60%;
   
}*/
}
@media (max-width: 360px) {
  .designtitle {
    /* margin-top:10px;
  margin-bottom:10px;*/
    width: 90% !important;
    font-size: 10px !important;
    padding: 5px !important;
  }
  .imgdesign {
    width: 90px !important;
    height: 80px !important;
  }
  .btndesign {
    padding: 2px !important;
    font-size: 9px !important;
    margin-top: 3px !important;
    margin-left: 15px !important;
  }
  .divdesign {
    float: left !important;
    border: 1px solid lightgray !important;
    height: 110px !important;
    margin-top: -50px !important;
    margin-bottom: 5px !important;
    margin-left: 1px !important;
  }
  .brandcard {
    padding-left: 12px !important;
  }
  .dropdowndesign {
    float: right !important;
    margin-right: 10px !important;
  }
  /*.stylefield{
  font-size: 11px !important;

    padding: 0px !important;
}*/
  .coldesign {
    flex: 0 0 100% !important;
    max-width: 86% !important;
  }
  .stylefield {
    font-size: 9px !important;
    padding: 0px !important;
    margin-left: -17px !important;
  }
  .colonb {
    text-align: center !important;
    position: absolute !important;
    margin-left: 10px !important;
  }
  .titleb {
    position: absolute !important;
    margin-left: 50% !important;
  }
}
@media (max-width: 280px) {
  .designtitle {
    /* margin-top:5px;
  margin-bottom:5px;*/
    width: 70% !important;
    font-size: 9px !important;
    /*padding: 10px !important;*/
  }
  .imgdesign {
    width: 80px !important;
    height: 60px !important;
  }
  .btndesign {
    padding: 3px !important;
    font-size: 9px !important;
    margin-top: 5px !important;
    margin-left: 9px !important;
  }
  /*.divdesign{
  float: left;
  border: 1px solid lightgray;
  height: 95px !important;
}*/
  .divdesign {
    float: left !important;
    border: 1px solid lightgray !important;
    height: 95px !important;
    margin-top: -50px !important;
    margin-bottom: 5px !important;
  }
  /*.brand-card {
    padding-left: 10px !important;
}*/
  .dropdowndesign {
    /*float: right;*/
    margin-right: 10px !important;
    /*margin-bottom:10px;*/
  }
  .stylefield {
    font-size: 10px !important;
    padding: 0px !important;
  }
  .coldesign {
    flex: 0 0 104% !important;
    max-width: 105% !important;
  }
  .detailsrow {
    display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
  }
  .selectedcolor {
    padding: 1px;
    text-align: center;
    width: 50%;
  }
}
@media (max-width: 450px) and (min-width: 350px) {
  .designtitle {
    /*margin-top:5px;
  margin-bottom:5px;*/
    width: 80% !important;
    font-size: 10px !important;
    padding: 10px !important;
  }
  .imgdesign {
    width: 120px !important;
    height: 90px !important;
  }
  .btndesign {
    padding: 4px !important;
    font-size: 10px !important;
    margin-top: 5px !important;
    margin-left: 25px !important;
  }
  .divdesign {
    float: left !important;
    border: 1px solid lightgray !important;
    height: 130px !important;
    margin-top: -50px !important;
    margin-bottom: 10px !important;
  }
  .brandcard {
    padding-left: 15px !important;
  }
  .dropdowndesign {
    float: right !important;
    margin-right: -34px !important;
    margin-bottom: 10px !important;
  }
  .stylefield {
    font-size: 10px !important;
    padding: 0px !important;
    margin-left: -16px !important;
  }
  /*.coldesign{
    flex: 0 0 50% !important;
    max-width: 100% !important;
}*/
  .coldesign {
    flex: 0 0 100% !important;
    max-width: 85% !important;
  }
  /*.stylefield{
  font-size: 9px !important;
    padding: 0px !important;
    margin-left: -17px !important;
}*/
  .colonb {
    text-align: center !important;
    position: absolute !important;
    margin-left: 10px !important;
  }
  .titleb {
    position: absolute !important;
    margin-left: 50% !important;
  }
  .detailsrow {
    display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
  }
  .selectedcolor {
    padding: 5px;
    text-align: center;
    width: 50%;
  }
}
@media (max-width: 540px) and (min-width: 450px) {
  .designtitle {
    /*margin-top:5px;
  margin-bottom:5px;*/
    width: 80% !important;
    font-size: 13px !important;
    padding: 10px !important;
  }
  .imgdesign {
    width: 150px !important;
    height: 120px !important;
  }
  .btndesign {
    padding: 4px !important;
    font-size: 10px !important;
    margin-top: 5px !important;
    margin-left: 35px !important;
  }
  .divdesign {
    float: left !important;
    border: 1px solid lightgray !important;
    height: 160px !important;
    margin-top: -50px !important;
    margin-bottom: 10px !important;
  }
  /*.brandcard {
    padding-left: 15px !important;
}*/
  .detailsrow {
    display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
  }
  .dropdowndesign {
    float: right !important;
    margin-right: -10px !important;
    margin-bottom: 5px !important;
  }
  .stylefield {
    font-size: 13px !important;
    padding: 0px !important;
    margin-left: -16px !important;
  }
  /*.coldesign{
    flex: 0 0 50% !important;
    max-width: 100% !important;
}*/
  .coldesign {
    flex: 0 0 100% !important;
    max-width: 85% !important;
  }
  /*.stylefield{
  font-size: 9px !important;
    padding: 0px !important;
    margin-left: -17px !important;
}*/
  .colonb {
    text-align: center !important;
    position: absolute !important;
    margin-left: 10px !important;
  }
  .titleb {
    position: absolute !important;
    margin-left: 50% !important;
  }

  .selectedcolor {
    padding: 5px;
    text-align: center;
    width: 50%;
  }
}
/*@media (max-width: 360px)
{
  
}*/
@media (max-width: 768px) and (min-width: 550px) {
  .designtitle {
    /*   margin-top:5px !important;
  margin-bottom:5px !important;*/
    width: 80% !important;
    font-size: 17px !important;
    padding: 10px !important;
  }
  .imgdesign {
    width: 220px !important;
    height: 150px !important;
  }
  .btndesign {
    padding: 4px !important;
    font-size: 10px !important;
    margin-top: 5px !important;
    margin-left: 70px !important;
  }
  .divdesign {
    float: left !important;
    border: 1px solid lightgray !important;
    height: 190px !important;
    margin-top: -40px !important;
    margin-bottom: 10px !important;
    margin-left: 40px !important;
  }
  /*.brand-card {
    padding-left: 15px !important;
}*/
  .dropdowndesign {
    float: right;
    margin-right: 5px !important;
    /*margin-bottom:10px !important;*/
  }
  .stylefield {
    font-size: 15px !important;
    padding: 0px !important;
    margin-left: 30px !important;
  }
  .coldesign {
    flex: 0 0 85% !important;
    max-width: 100% !important;
  }
}
@media (max-width: 700px) {
  .designtable {
    display: none;
  }
}

@media (min-width: 700px) {
  .tablebtn {
    display: none;
  }
}
@media (max-width: 375px) and (min-width: 350px) {
  .tdhead {
    font-size: 8px;
  }
  .tdsize {
    font-size: 8px;
  }
  .tdunit {
    font-size: 12px;
    width: 35px;
    padding: 2px;
  }
  .tdageform {
    padding: 2px;
    font-size: 13px;
    width: 40px;
  }
  .tdageto {
    padding: 2px;
    width: 40px;
    font-size: 13px;
  }
  .tdfactory {
    padding: 7px !important;
    font-size: 12px !important;
    width: 35px !important;
    height: 23px !important;
  }
  .tdquantity {
    padding: 7px !important;
    font-size: 12px !important;
    width: 36px !important;
    height: 23px !important;
  }
  .tabset {
    margin-left: -13px;
  }
}
@media (max-width: 320px) {
  .tabset {
    margin-left: -9px;
    overflow: auto;
  }
}
@media (max-width: 300px) {
  .tabset {
    margin-left: -9px;
    overflow: auto;
  }
}
@media (max-width: 450px) {
  .tdhead {
    font-size: 10px !important;
  }
  .tdsize {
    font-size: 10px !important;
  }
  .tdunit {
    padding: 3px !important;
    font-size: 15px !important;
    width: 40px !important;
    height: 27px !important;
  }
  .tdageform {
    padding: 2px !important;
    font-size: 13px !important;
    width: 42px !important;
    height: 27px !important;
  }
  .tdageto {
    padding: 2px !important;
    font-size: 13px !important;
    width: 42px !important;
    height: 27px !important;
  }
  .tdfactory {
    padding: 2px !important;
    width: 42px !important;
    height: 27px !important;
    font-size: 12px !important;
  }
  .tdquantity {
    padding: 2px !important;
    width: 42px !important;
    height: 27px !important;
    font-size: 12px !important;
  }
}
@media (max-width: 540px) and (min-width: 500px) {
  .tdunit {
    padding: 5px !important;
    font-size: 15px !important;
    width: 45px !important;
    height: 32px !important;
  }
  .tdageform {
    padding: 1px !important;
    width: 40px !important;
    height: 32px !important;
    font-size: 13px !important;
  }
  .tdageto {
    padding: 1px !important;
    width: 40px !important;
    height: 32px !important;
    font-size: 13px !important;
  }
  /*.tdfactory{
    padding: 2px !important;
    width: 42px !important;
    height: 27px !important;
    font-size: 12px !important;
  }
 .tdquantity{
     padding: 2px !important;
    width: 42px !important;
    height: 27px !important;
    font-size: 12px !important;
 }*/
}
@media (max-width: 1040px) {
  .detailside {
    display: none;
  }
}
</style>
